const itLocale = {
  dashboard: `Pannello di controllo`,
  engage: `Ingaggiare`,
  assets: `Attività`,
  submissions: `Presentazioni`,
  impact: `Impatto`,
  programmes: `Programmi`,
  interactions: `Interazioni`,
  donations: `Donazioni`,
  impact_strategy: `Strategia di impatto`,
  my_profile: `Il mio profilo`,
  organisation: `Organizzazione`,
  users: `Utenti`,
  profile: `Profilo`,
  help: `Aiuto`,
  logout: `Esci`,
  insights: `Approfondimenti`,
  data: `Dati`,
  progress: `Progressi`,
  ideas: `Idee`,
  reviewed: `Recensito`,
  in_progress: `In corso`,
  pending_review: `In attesa di revisione`,
  most_popular_theme: `Tema più popolare`,
  local_resident: `Residente locale`,
  local_business: `Impresa locale`,
  charitable_group: `Gruppo di beneficenza`,
  other_stakeholder: `Altri soggetti interessati`,
  cultural: `Culturale`,
  environmental: `Ambientale`,
  economic: `Economico`,
  educational: `Educativo`,
  social: `Sociale`,
  responder_types: `Tipi di risponditore`,
  most_popular_category: `Categoria più popolare`,
  green_spaces: `Spazi verdi`,
  local_tourism: `Turismo locale`,
  skills_development: `Sviluppo delle competenze`,
  other: `Altro`,
  most_popular_sub_category: `Sottocategoria più popolare`,
  grassland: `Prateria`,
  burgers: `Hamburger`,
  green_skills: `Competenze verdi`,
  filters: `Filtri`,
  theme: `Tema`,
  category: `Categoria`,
  sub_category: `Sottocategoria`,
  ideas_by_phase: `Idee per fase`,
  oops: `Ops! Il nome utente/password potrebbero essere errati`,
  forgot_password: `Ha dimenticato la password?`,
  forgot_password_line1: `Se disponi di un account, riceverai un'e-mail di "Reimpostazione password" dal supporto BizGive. Segui il collegamento contenuto nell'e-mail per creare una nuova password.`,
  forgot_password_line2: `Controlla anche la cartella spam.`,
  forgot_password_line3: `Se non ricevi un'e-mail potresti non avere un account attivo. Contatta il supporto BizGive.`,
  forgot_password_header: `Per favore controlla la tua casella di posta`,
  incorrect_email_id: `Controlla l'ID email che hai inserito.`,
  forget_password: `Dimentica la password`,
  forget_password_hint: `Si prega di utilizzare più di 8 caratteri, una lettera maiuscola e minuscola, un numero e un carattere speciale.`,
  date_submitted: `Data di invio`,
  need: `Bisogno`,
  attributes: `Attributi`,
  happy_to_be_contacted: `Contento di essere contattato?`,
  actions: `Azioni`,
  add_comment: `Aggiungi commento`,
  date_actioned: `Data dell'azione`,
  actioned_by: `Azionato da`,
  back_to_map: `Torna alla mappa`,
  submitter_type: `Tipo di mittente`,
  submitter_location: `Posizione del mittente`,
  submission_location: `Luogo di invio`,
  categories: `Categorie`,
  yes: `SÌ`,
  no: `NO`,
  save: `Salva`,
  idea_location: `Posizione dell'idea`,
  please_populate: `Per favore compila`,
  comments_added_successfully: `Commenti aggiunti con successo`,
  see_location: `Vedi Posizione`,
  feedback: `Feedback`,
  feedback_by_phase: `Feedback per fase`,
  feedback_location: `Posizione del feedback`,
  comment: `Commento`,
  asset: `Risorsa`,
  phase: `Fase`,
  idea: `Idea`,
  submitter: `Inviato`,
  requestedContact: `Contatto richiesto?`,
  collaborate: `Collaborare`,
  contact_by_phase: `Contatto per fase`,
  collaborate_location: `Collabora posizione`,
  number_of_employees: `No. Dipendenti`,
  global_annual_turnover: `Fatturato annuo globale (milioni di £)`,
  industry: `Industria`,
  services_provided: `Servizi forniti`,
  services_description: `Descrizione dei servizi`,
  renewable_experience: `Esperienza rinnovabile?`,
  requested_introduction_to_tier_one_contractors: `Hai richiesto la presentazione agli appaltatori di livello 1?`,
  organization_name: `Nome dell'organizzazione`,
  website: `Sito web`,
  overview: `Panoramica`,
  total_visitors: `Visitatori totali`,
  feedback_submitted: `Feedback inviato`,
  ideas_submitted: `Idee presentate`,
  collaborations_submitted: `Collaborazioni presentate`,
  pending_actions: `Azioni in sospeso`,
  three_month_historical_visitors: `Visitatori storici di 3 mesi`,
  submission_type: `Tipo di invio`,
  collaborations: `Collaborazioni`,
  applications: `Applicazioni`,
  action_required: `Azione richiesta`,
  pending_response: `In attesa di risposta`,
  pre_approved: `Pre-approvato`,
  approved: `Approvato`,
  declined: `Rifiutato`,
  your_session_will_expire_in: `La tua sessione scadrà tra...`,
  select_whether_you_would_like_to_stay_logged_in_or_log_out: `Seleziona se desideri rimanere connesso o disconnetterti. Se non fai nulla verrai automaticamente disconnesso per motivi di sicurezza.`,
  stay_logged_in: `Rimani connesso`,
  log_out: `Esci`,
  all_phases: `Tutte le fasi`,
  login: `Login`,
  not_registered_yet: `Non sei ancora registrato?`,
  sign_up: `Iscrizione`,
  user_terms: `Termini per l'utente`,
  privacy_policy: `politica sulla riservatezza`,
  create_an_account_to_apply_for_support: `Crea un account per richiedere supporto`,
  are_you_impact_funder_contact_us: `Sei un finanziatore ad impatto? Contattaci`,
  confirm_password: `Conferma password`,
  password_must_include: `La password deve includere:`,
  more_than_eight_characters: `- Più di 8 caratteri`,
  an_upper_and_lower_case_character: `- Un carattere maiuscolo e minuscolo`,
  a_number: `- Un numero`,
  a_special_character: `- Un personaggio speciale`,
  i_accept_the: `Accetto il`,
  register: `Registro`,
  connect_with_funders_and_design_your_opportunities_to_create_positive_impact: `Connettiti con i finanziatori e progetta le tue opportunità per creare un impatto positivo`,
  or_login_to_create_your_free_BizGive_account: `o accedi per creare il tuo account BizGive gratuito.`,
  discover: `Scoprire`,
  funding_programmes_and_create_a_profile_to_receive_alerts: `programmi di finanziamento e creare un profilo per ricevere avvisi.`,
  submit: `Invia`,
  applications_auto_verified_against_funder_criteria: `domande, verificate automaticamente rispetto ai criteri del finanziatore.`,
  share: `Condividere`,
  content_track_impact_and_capture_funder_feedback: `contenuti, monitorare l'impatto e acquisire il feedback dei finanziatori.`,
  here: `Qui`,
  please_enter_password: `Inserisci la password`,
  ok: `OK`,
  confirm_email: `Conferma email`,
  log_in: `Login`,
  please_enter_email: `Inserisci l'e-mail`,
  the_input_is_not_valid_email: `L'input non è valido E-mail!`,
  the_new_password_that_you_entered_do_not_match: `La nuova password che hai inserito non corrisponde!`,
  the_new_email_that_you_entered_do_not_match: `La nuova email che hai inserito non corrisponde!`,
  please_confirm_your_password: `Inserisci la password di conferma`,
  please_accept_the_user_terms: `Si prega di accettare i Termini per l'utente`,
  change_password: `Cambiare la password`,
  password: `Password`,
  we_just_emailed: `Abbiamo appena inviato un'e-mail`,
  please_click_on_the_link_in_your_email_to_activate_your_account: `Fai clic sul collegamento nella tua email per attivare il tuo account`,
  please_enter_a_valid_password: `Inserisci una password valida`,
  you_have_been_logged_out_due_to_inactivity: `Sei stato disconnesso per inattività...`,
  please_enter_a_valid_password_using_the_guidance_below: `Errore: inserisci una password valida utilizzando le indicazioni riportate di seguito.`,
  entity: `Entità`,
  media: `Media`,
  logo: `Logo`,
  profile_create: `Crea profilo`,
  lets_get_started: `Cominciamo`,
  name_and_location: `Nome e posizione`,
  what_is_the_legal_Name_of_your_entity: `Qual è il nome legale della tua entità?`,
  what_entity_name_would_like_to_be_displayed: `Quale nome dell'entità vorrebbe essere visualizzato?`,
  what_is_your_registered_address: `Qual è il tuo indirizzo registrato?`,
  description: `Descrizione`,
  add_your_description: `Aggiungi la tua descrizione`,
  add_your_social_media_details: `Aggiungi i tuoi dettagli sui social media`,
  what_is_your_website: `Qual è il tuo sito web?`,
  optional: `Opzionale`,
  add_your_company_logo: `Aggiungi il logo della tua azienda`,
  upload: `Caricamento`,
  organization_profile: `Profilo dell'organizzazione`,
  description_company: `Descrizione`,
  detail: `Dettaglio`,
  registered_address: `Indirizzo registrato`,
  proceed: `Procedere`,
  previous: `Precedente`,
  save_n_exit: `Salva ed esci`,
  next: `Prossimo`,
  enter: `Entra`,
  complete: `Completare`,
  my_details: `I miei dettagli`,
  your_name: `Il tuo nome`,
  phone_number: `Numero di telefono`,
  job_title: `Titolo di lavoro`,
  biz_give_role: `BizGive Ruolo`,
  member_since: `Membro da allora`,
  my_programmes: `I miei programmi`,
  delete_file_confirmation: `Conferma eliminazione file`,
  please_confirm_you_are_happy_to_permanently_delete_this_file: `Conferma che sei disposto a eliminare definitivamente questo file?`,
  delete: `Eliminare`,
  cancel: `Cancellare`,
  create_password: `Crea password`,
  invite_new_user: `Invita nuovo utente`,
  regular_users: `Utenti regolari`,
  can_not_view_or_edit_anything_by_default: `non è possibile visualizzare o modificare nulla per impostazione predefinita. Tutti gli utenti invitati iniziano con questo stato. Puoi aggiungerli a Programmi per visualizzare e/o modificare quel programma specifico e i relativi contenuti.`,
  organization_admins: `Amministratori dell'organizzazione`,
  can_access_and_edit_everything_in_the_platform: `può accedere e modificare tutto nella piattaforma. È possibile assegnare questo privilegio agli utenti esistenti in questa schermata.`,
  user_name: `Nome utente`,
  make_admin: `Diventa amministratore`,
  remove_admin: `Rimuovi amministratore`,
  invited: `INVITATO`,
  regular: `REGOLARE`,
  admin: `AMMINISTRATORE`,
  remove_user_from_your_organization: `Rimuovi l'utente dalla tua organizzazione`,
  please_confirm_you_are_to_permanently_remove_this_user: `Confermi che intendi rimuovere definitivamente questo utente?`,
  none_of_their_programmes_or_interaction_data_will_be_removed: `Nessuno dei loro programmi o dati di interazione verrà rimosso`,
  remove_user: `Rimuovi utente`,
  remove_admin_rights: `Rimuovi i diritti di amministratore`,
  remove: `Rimuovere`,
  as_an_Organization_Admin: `come amministratore dell'organizzazione.`,
  they_will_then_only_be_able_to_view_and_edit_programmes_that_they_manage: `Potranno quindi visualizzare e modificare solo i programmi che gestiscono.`,
  enter_email_address: `Inserisci l'indirizzo email`,
  confirm_email_address: `Conferma l'indirizzo e-mail`,
  invite: `Invitare`,
  add_admin_rights: `Aggiungi diritti di amministratore`,
  make: `Fare`,
  an_organization_admin: `un amministratore dell'organizzazione`,
  they_will_be_able_to_view_and_edit_everything_in_your_organization: `Saranno in grado di visualizzare e modificare tutto nella tua organizzazione.`,
  charity_can_not_view_or_edit_anything_by_default: `non è possibile visualizzare o modificare nulla per impostazione predefinita. Tutti gli utenti invitati iniziano con questo stato. Puoi aggiungerli alle applicazioni per visualizzare e/o modificare quella specifica applicazione e il relativo contenuto.`,
  charity_can_access_and_edit_everything_in_the_platform: `può accedere e modificare tutto nella piattaforma. È possibile assegnare questo privilegio agli utenti esistenti in questa schermata.`,
  none_of_their_applications_or_interaction_data_will_be_removed: `Nessuna delle loro applicazioni o dati di interazione verrà rimossa`,
  they_will_then_only_be_able_to_view_and_edit_applications_that_they_manage: `Potranno quindi visualizzare e modificare solo le applicazioni che gestiscono.`,
  the_invited_user_already_has_an_account_linked_to_this_email_address: `L'utente invitato ha già un account collegato a questo indirizzo email. Controlla l'elenco degli utenti o contatta BizGive per il supporto.`,
  all_programmes: `Tutti i programmi`,
  download: `Scaricamento`,
  search_placeholder: `Ricerca...`,
  actions_required: `Azioni richieste`,
  opportunity: `Opportunità`,
  date_applied: `Data di applicazione`,
  date_requested: `Data richiesta`,
  net_vote: `Voto netto (elettori)`,
  date_approved: `Data di approvazione`,
  date_declined: `Data rifiutata`,
  applied: `APPLICATO`,
  in_edit: `NELLA MODIFICA`,
  pre_approved_caps: `PRE-APPROVATO`,
  approved_caps: `APPROVATO`,
  declined_caps: `RIFIUTATO`,
  review: `Revisione`,
  customize_your_download: `Personalizza il tuo download`,
  select_application_status: `Seleziona Stato dell'applicazione`,
  share_and_manage_voting: `Condividi e gestisci la votazione`,
  current_share_access_closing_date: `Data di chiusura dell'accesso alle condivisioni corrente`,
  invited_users_will_receive_an_email_with_access_details: `Gli Utenti Invitati riceveranno una email con i dettagli di accesso, accessibili fino alla Data di Chiusura. Potranno solo visualizzare i loro voti.`,
  invited_voters: `Elettori invitati`,
  add_email_address: `Aggiungi indirizzo email`,
  reported_grants: `Sovvenzioni segnalate`,
  planned_grants: `Sovvenzioni pianificate`,
  remaining_budget: `Bilancio rimanente`,
  total_budget: `Bilancio totale`,
  do_you_wish_to_request_indicators: `Desideri richiedere degli indicatori?`,
  the_entity_will_be_asked_to_create: `All'entità verrà chiesto di creare indicatori per la propria opportunità allineati ai risultati selezionati.`,
  please_confirm_you_wish_to_complete_this_item: `Questo passaggio è completo.`,
  requested: `Richiesto`,
  do_you_wish_the_applicant_to_create_indicators_to_measure_its_progress: `Desideri che il richiedente crei indicatori per misurare i suoi progressi?`,
  volunteering: `Volontariato`,
  day: `Giorno`,
  inkind: `In natura`,
  budget_period_end: `Fine del periodo di budget`,
  budget_available: `Budget disponibile`,
  budget_amount: `Importo del budget`,
  remaining: `Rimanente`,
  select_filter: `Seleziona un filtro`,
  donation_title: `Donazione`,
  email_id_title: `ID e-mail`,
  add_user: `Aggiungi utente`,
  delete_title: `Eliminare`,
  add_title: `Aggiungere`,
  delete_user: `Elimina utente`,
  action_cannot_undone: `Questa azione non può essere annullata. Tutte le opportunità gestite saranno comunque accessibili agli amministratori dell'account.`,
  confirm_title: `Confermare`,
  adding_admin_rights: `L'aggiunta dei diritti di amministratore offre all'utente la possibilità di creare opportunità, aggiornare il profilo dell'organizzazione, aggiungere e rimuovere utenti e creare amministratori.`,
  remove_admin_rights_para: `La rimozione dei diritti di amministratore impedisce all'utente di creare opportunità, aggiornare il profilo dell'organizzazione, aggiungere e rimuovere utenti e creare amministratori.`,
  save_private: `Salvato (privato)`,
  planned_shared: `Pianificato (condiviso)`,
  invoice_requested: `Fattura richiesta`,
  invoice_received: `Fattura ricevuta`,
  reported_title: `Segnalato`,
  confirmed_title: `Confermato`,
  report_donation: `Segnala donazione`,
  cancel_title: `Cancellare`,
  save_title: `Salva`,
  grant: `Concessione`,
  awarded: `Premiato`,
  award_title: `Premio`,
  type_title: `Tipo`,
  invoice_title: `Fattura`,
  condition_title: `Condizione`,
  reported_date_title: `Data segnalata`,
  next_action_title: `Azione successiva`,
  donation_created: `Successo: donazione creata`,
  donation_updated: `Successo: donazione aggiornata`,
  donation_deleted: `Successo: donazione eliminata`,
  view_donation: `Visualizza donazione`,
  select_title: `Selezionare`,
  approved_opportunities_planned_impact: `Opportunità approvate (Impatto pianificato)`,
  achieved_impact: `Impatto ottenuto (opportunità completate)`,
  achieved_beneficiaries: `Beneficiari raggiunti`,
  outputs_achieved: `Risultati raggiunti`,
  content_received: `Contenuto ricevuto (impatto ottenuto)`,
  opportunity_name: `Nome dell'opportunità`,
  entity_name: `Nome dell'entità`,
  due_date: `Scadenza`,
  number: `Numero`,
  approved_date: `Data di approvazione`,
  view: `Visualizzazione`,
  primary_UN_SDG: `Obiettivi di sviluppo sostenibile principali delle Nazioni Unite `,
  opportunity_type: `Tipo di opportunità`,
  charity_name: `Nome di beneficenza`,
  select_type: `Seleziona un tipo`,
  please_fill_amount: `Si prega di compilare l'importo`,
  enter_title: `Entra`,
  please_enter_conditions: `inserisci la condizione`,
  please_select_action: `Seleziona un'azione`,
  actions_title: `Azioni`,
  select_action: `Seleziona Azione`,
  payment_reference: `Riferimento al pagamento`,
  please_select_amount: `Seleziona un importo`,
  enter_payment_reference: `Inserisci il riferimento del pagamento`,
  upload_counterpart_behalf: `Carica la fattura per conto della controparte`,
  equivalent_value: `Valore equivalente`,
  amount_title: `Quantità`,
  purchase_order: `Ordinazione d'acquisto`,
  files_title: `File`,
  company_name_title: `Nome dell'azienda`,
  programme_type_title: `Tipo di programma`,
  application_start_date: `Data di inizio della domanda`,
  application_end_date: `Data di fine della domanda`,
  location_title: `Posizione`,
  next_update_outcome: `Prossimo aggiornamento/risultato`,
  donations_by: `Donazioni di`,
  decision_date: `Data della decisione`,
  decision_start_date: `Data di inizio della decisione`,
  decision_end_date: `Data di fine della decisione`,
  opportunity_i_manage: `Opportunità che gestisco`,
  select_template: `Seleziona modello`,
  please_select_template: `Seleziona un modello`,
  save_draft: `Salva bozza`,
  all_opportunities: `Tutte le opportunità`,
  excel_title: `Eccellere`,
  round: `Girare`,
  select_donation_status: `Seleziona Stato della donazione`,
  delete_file: `Elimina file`,
  deleting_file_para: `L'eliminazione di questo file lo rimuoverà definitivamente`,
  delete_donation: `Elimina donazione`,
  delete_donation_para: `L'eliminazione di questa donazione rimuoverà permanentemente tutte le informazioni correlate`,
  cancel_changes: `Annulla modifiche`,
  remove_title: `Rimuovere`,
  will_remove_changes_to_donation: `Ciò rimuoverà tutte le modifiche apportate alla donazione`,
  edit_title_uppercase: `MODIFICARE`,
  current_report_period: `Periodo del rapporto corrente`,
  current_report_open: `Rapporto corrente aperto`,
  current_report_close: `Chiudi il rapporto corrente`,
  manage_title: `Maneggio`,
  open_date: `Data di apertura`,
  close_date: `Data di chiusura`,
  period_title: `Periodo`,
  reporter_title: `Reporter`,
  edit_title: `Modificare`,
  about_me: `Su di me`,
  please_enter_valid_name: `Inserisci un nome valido`,
  please_enter_only_alphabets: `Per favore inserisci solo alfabeti`,
  name_Title: `Nome`,
  phone_number_title: `Numero di telefono`,
  upload_purchase_order: `Carica ordine di acquisto`,
  programme_dates: `Date del programma`,
  programme_start: `Inizio del programma`,
  programme_end: `Fine del programma`,
  currency: `Valuta`,
  current_budget_year_end: `Fine anno del budget corrente:`,
  approved_summary: `Riepilogo approvato`,
  please_select_programme: `Seleziona un programma`,
  generate: `Generare`,
  opportunities_supported: `Opportunità supportate`,
  approved_opportunities: `Opportunità approvate`,
  planned_impact: `Impatto pianificato (opportunità approvate)`,
  grants: `Sovvenzioni`,
  planned_beneficiaries: `Beneficiari previsti`,
  direct: `Diretto`,
  indirect: `Indiretto`,
  primary: `Primario`,
  secondary: `Secondario`,
  all: `Tutto`,
  programme_name: `Nome del programma`,
  reset: `Reset`,
  my_feedback: `Il mio feedback`,
  feedback_title: `Feedback`,
  select_opportunity: `Seleziona Opportunità`,
  please_select_opportunity: `Seleziona un'opportunità`,
  select_report: `Seleziona Segnala`,
  please_select_report: `Seleziona un rapporto`,
  editing_title: `Modifica`,
  enabled_title: `Abilitato`,
  locked_title: `Bloccato`,
  content_title_uppercase: `CONTENUTO`,
  feedback_title_uppercase: `FEEDBACK`,
  no_data: `Nessun dato`,
  program_status: `Stato del programma`,
  un_sdgs: `Obiettivi di sviluppo sostenibile delle Nazioni Unite`,
  more_title: `Di più`,
  program_location: `Posizione del programma`,
  asset_name: `Nome della risorsa`,
  asset_location: `Posizione della risorsa`,
  portfolio_title: `Portfolio`,
  review_title: `Revisione`,
  payment_date: `Data di pagamento`,
  secondary_UN_SDG: `SDG secondari delle Nazioni Unite`,
  summary_title: `Riepilogo`,
  select_the_programme_you_wish_to_receive: `Seleziona il programma per il quale desideri ricevere un report sulla risorsa selezionata sopra.`,
  manager: `Manager`,
  add_managers_who_can_invite_reporter: `Aggiungi gestori che possono invitare reporter per tuo conto. Nota: gli utenti interni della tua organizzazione possono essere aggiunti dal tuo`,
  admin_page: `pagina di amministrazione`,
  inviting_existing_user: `Invito dell'utente esistente`,
  invite_new: `Invita nuovo`,
  external_users: `utenti esterni`,
  by_entering_their_email_address: `inserendo il loro indirizzo email`,
  optional_add_reporters: `Opzionale. Aggiungi reporter che completeranno i report del programma per le tue risorse.`,
  manage_report: `Gestisci rapporto`,
  add_asset: `Aggiungi risorsa`,
  budget_history: `Storia del bilancio`,
  milestones: `Pietre miliari`,
  programme_name_title: `Nome del programma`,
  application: `Applicazione`,
  create: `Creare`,
  comment_title: `Commento`,
  cash_donation_saved_successfully: `Donazione in contanti salvata.`,
  upload_invoice: `Carica fattura`,
  upload_title: `Caricamento`,
  confirm_receipt: `Conferma ricevuta`,
  received_title: `Ricevuto`,
  please_confirm_donation_received: `Si prega di confermare che questa donazione è stata ricevuta.`,
  success_donation_received: `Successo: donazione ricevuta`,
  success_invoice_uploaded: `Operazione riuscita: fattura caricata`,
  click_to_upload: `Fare clic per caricare`,
  settings: `Impostazioni`,
  internal_only: `Solo interno`,
  visibility_title: `Visibilità`,
  public_title: `Pubblico`,
  private: `Privato`,
  completed: `Completato`,
  content_package: `Pacchetto di contenuti`,
  please_select_interaction_status: `Seleziona lo stato dell'interazione.`,
  go_back: `Torna indietro`,
  budget_dates: `Date del bilancio`,
  budget_recurring: `Budget ricorrente?`,
  objectives: `Obiettivi`,
  supporting_materials: `Materiale di supporto`,
  web_links: `Collegamenti Web`,
  administrators: `Amministratori`,
  application_criteria: `Criteri di applicazione`,
  documentation_required: `Documentazione richiesta`,
  available_support: `Supporto disponibile`,
  none: `Nessuno`,
  eligibility_checklist: `Lista di controllo di idoneità`,
  location_supported: `Posizione supportata`,
  project_must_be_within: `Il progetto deve essere all'interno`,
  of_this_location: `di questa località`,
  expand_all: `Espandi tutto`,
  entities_supported: `Entità supportate`,
  mandatory: `Obbligatorio`,
  expected_budget: `Budget previsto`,
  per_opportunity: `Per opportunità`,
  specific_skills_available: `Abilità specifica disponibile`,
  general_skills_available: `Competenze generali disponibili`,
  any: `Qualunque`,
  application_accepted_between: `Domanda accettata tra`,
  donation_to_be_made_between: `Donazione da effettuare tra`,
  interim_update_requested: `Richiesto aggiornamento provvisorio`,
  final_report_requested: `Richiesto rapporto finale`,
  show_all_goals: `Mostra tutti gli obiettivi`,
  any_location: `Qualsiasi posizione`,
  apply: `Fare domanda a`,
  eligibility: `Idoneità`,
  before_applying_please_confirm_your_eligibility: `Prima di candidarti, conferma la tua idoneità:`,
  please_confirm_that_your_project_is_located_within_or_that_it_benefits_those_within_the_supported_locations: `Conferma che il tuo progetto si trova all'interno delle località supportate o che apporta vantaggi a chi si trova all'interno.`,
  please_select: `Seleziona`,
  project_description: `Descrizione del progetto`,
  please_share_a_summary_of_your_project: `Per favore condividi un riassunto del tuo progetto`,
  enter_project_summary: `Inserisci il riepilogo del progetto`,
  please_describe_your_project: `Per favore descrivi il tuo progetto`,
  for_example_what_do_you_want_to_do: `Ad esempio, cosa vuoi fare, come lo farai, hai identificato un'esigenza per il progetto e chi lo guiderà?`,
  this_application_is_to: `Questa applicazione è per:`,
  application_accepted: `Domande accettate:`,
  application_sections: `Sezioni applicazioni`,
  application_preview: `Anteprima dell'applicazione`,
  application_guidance: `Guida all'applicazione`,
  in_the_application_form: `Nel modulo di domanda ti verrà chiesto di condividere i dettagli di un progetto per il quale richiedi il finanziamento.`,
  next_title: `'Prossimo'`,
  save_n_exit_title: `"Salva ed esci"`,
  submit_title: `'Invia'`,
  saves_your_data_and_moves: `salva i tuoi dati e ti sposta alla schermata successiva nel modulo di domanda. Le tue risposte verranno salvate automaticamente, a meno che tu non abbia un problema di connettività Internet.`,
  saves_your_data_and_closes: `salva i tuoi dati e chiude il modulo di domanda, a cui potrai tornare in seguito. Dovrai compilare tutti i campi obbligatori per "Salva ed esci" (puoi inserire valori casuali, ad esempio X come segnaposto, in cl`,
  sends_your_application_form_to_the_company: `invia il modulo di domanda all'azienda. Questo pulsante appare nella schermata finale del modulo di domanda.`,
  to_access_a_saved_application: `Per accedere a un'applicazione salvata: fare clic su Applicazioni e Azione richiesta.`,
  to_view_a_submitted_application: `Per visualizzare una domanda inviata: fare clic su Domande e risposta in attesa`,
  start: `Inizio`,
  application_form: `Modulo di domanda`,
  your_application: `La tua candidatura`,
  what_is_the_name_of_your_project: `Qual è il nome del tuo progetto?`,
  please_complete_each_screen: `Si prega di completare ogni schermata del modulo di domanda. Nell'ultima schermata vedrai un'anteprima della tua domanda e da qui potrai fare clic su "Invia" per inviarla all'azienda.`,
  project_name: `Nome del progetto`,
  add_a_banner_image: `Aggiungi un'immagine banner`,
  this_will_show_at_the_top_of_your_application_form: `Questo verrà visualizzato nella parte superiore del profilo del tuo programma.`,
  choose_an_image_from_bizGive: `Scegli un'immagine da BizGive`,
  upload_your_own_banner_image: `Carica la tua immagine banner`,
  additional_images: `Immagini aggiuntive`,
  bizGive_images: `BizGive Immagini`,
  where_is_your_project_located: `Dove si trova il tuo progetto?`,
  search_for_and_select_the_address_of_your_location: `Cerca e seleziona l'indirizzo della tua/e sede/i. Oppure in alternativa,`,
  click: `clic`,
  any_place_or_point_on_the_map_to_select_it: `qualsiasi luogo o punto sulla mappa per selezionarlo.`,
  add_or_Edit_the_name_for_your_location_and_press: `Aggiungi o modifica il nome della tua posizione e premi "Aggiungi un altro" per aggiungere altre posizioni.`,
  add_additional_location: `Aggiungi ulteriore posizione`,
  one_or_more_project_locations_are_located_outside_of_the_programme_area: `Una o più sedi del progetto si trovano al di fuori dell'area del programma.`,
  please_change_your_project_location_or_explain_how_your_project_will_benefit_the_programme_area_below: `Modifica la sede del tuo progetto OPPURE spiega in che modo il tuo progetto porterà benefici all'area del programma di seguito`,
  how_will_it_benefit_the_programme_area: `Quali saranno i benefici per l’area del programma?`,
  project_dates: `Date del progetto`,
  when_is_your_project_happening: `Quando avverrà il tuo progetto?`,
  this_can_be_an_estimate: `Questa può essere una stima, poiché ti verrà chiesto di modificare o confermare le date se la tua richiesta ha esito positivo.`,
  projects_must_start_within_12_months: `I progetti devono iniziare entro i mesi OpportunitàStartWithinMonths.`,
  projects_must_not_be_longer_than_6_months: `I progetti non devono essere più lunghi dei mesi OpportunitàLengthMonths.`,
  estimated_start: `Inizio stimato`,
  estimated_finish: `Finitura stimata`,
  is_there_a_deadline_when_you_need_to_receive_a_donation_by: `C'è una scadenza entro la quale devi ricevere una donazione affinché il tuo progetto possa andare avanti?`,
  if_not_please_leave_this_blank: `In caso contrario, lascia vuoto questo campo.`,
  enter_date: `Inserisci la data`,
  what_support_are_you_applying_for: `Per quale sostegno stai richiedendo?`,
  in_kind: `In natura`,
  how_much_are_you_applying_for: `Quanto ti candidi?`,
  enter_amount: `Inserisci l'importo`,
  how_much_does_your_project_cost_in_total: `Quanto costa in totale il tuo progetto?`,
  you_are_applying_for_percentage_of_the_total_cost_of_your_project: `Stai richiedendo una percentuale del costo totale del tuo progetto`,
  how_will_you_use_any_support_awarded: `Come utilizzerete il sostegno concesso?`,
  enter_number_of_items_or_activity: `Inserisci il numero di articoli o attività`,
  enter_description: `Inserisci la descrizione`,
  where_will_additional_funds_come_from: `Da dove arriveranno i fondi aggiuntivi?`,
  internal_resources: `Risorse interne`,
  external_funding: `Finanziamenti esterni`,
  have_you_already_secured_this_funding: `Hai già ottenuto questo finanziamento?`,
  can_your_project_proceed_if_you: `Il tuo progetto può procedere se non ti assicuri questo finanziamento aggiuntivo?`,
  what_outputs_will_the_support_help_you_to_achieve: `Quali risultati il ​​sostegno ti aiuterà a raggiungere?`,
  your_outputs_will_show_like_this_in_your_application_form: `I tuoi risultati verranno visualizzati in questo modo nel modulo di domanda:`,
  what_items_or_services_do_you_need: `Di quali articoli o servizi hai bisogno?`,
  for: `per`,
  what_volunteering_support_do_you_need: `Di quale supporto di volontariato hai bisogno?`,
  edit_image: `Modifica immagine`,
  change_image: `Cambia immagine`,
  delete_image: `Elimina immagine`,
  click_delete_to_remove_this_image: `Fai clic su "Elimina" per rimuovere questa immagine.`,
  option: `Opzione`,
  add: `Aggiungere`,
  tips: `Suggerimenti`,
  what_is_an_output: `Cos'è un'uscita?`,
  an_output_is_what_you_expect_to_achieve_from_the_support_awarded_below_are_some_examples: `Un risultato è ciò che ci si aspetta di ottenere dal sostegno concesso. Di seguito sono riportati alcuni esempi:`,
  number_new_teaching_assistants_trained: `Formati 5 nuovi assistenti didattici`,
  number_new_teachers_trained: `Formati 10 nuovi insegnanti`,
  number_workshops_hosted: `3 workshop ospitati`,
  number_energy_audits_completed: `4 audit energetici completati`,
  number_people_more_aware_of_climate_change_in_our_community: `200 persone più consapevoli del cambiamento climatico nella nostra comunità`,
  number_new_playground_installed: `1 nuovo parco giochi installato`,
  please_enter: `Per favore entra`,
  which_of_the_company_impact_objectives_will_your_project_support: `Quale degli obiettivi di impatto dell’azienda sosterrà il tuo progetto?`,
  what_outcomes_do_you_hope_your_project_will_achieve: `Quali risultati speri che il tuo progetto raggiunga?`,
  what_is_an_outcome: `Cos'è un risultato?`,
  an_outcome_is_the_change_you_hope_to_see_as_a_result_of_your_project_below_are_some_examples: `Un risultato è il cambiamento che speri di vedere come risultato del tuo progetto. Di seguito sono riportati alcuni esempi.`,
  objective_protect_and_improve_the_local_environment: `Obiettivo: proteggere e migliorare l'ambiente locale`,
  outcome_improve_fish_populations_through_river_restoration: `Risultato: Migliorare le popolazioni ittiche attraverso il ripristino dei fiumi.`,
  objective_create_and_improve_local_amenities: `Obiettivo: creare e migliorare i servizi locali`,
  outcome_improve_the_energy_efficiency_of_the_village_hall_with_new_windows: `Risultato: Migliorare l'efficienza energetica del municipio con nuove finestre.`,
  objective_engage_the_local_community: `Obiettivo: coinvolgere la comunità locale`,
  outcome_reduce_isolation_and_loneliness_in_older_people: `Risultato: ridurre l’isolamento e la solitudine negli anziani.`,
  how_will_you_achieve_these_outcomes: `Come raggiungerai questi risultati?`,
  briefly_describe_your_approach_to_achieving_the_outcomes: `Descrivi brevemente il tuo approccio per raggiungere i risultati.`,
  below_are_some_examples: `Di seguito sono riportati alcuni esempi:`,
  we_will_remove_excess_silt: `Rimuoveremo il limo in eccesso, in modo da ripristinare i terreni riproduttivi dei pesci.`,
  we_will_replace_our_old_windows_with_triple_glazed_windows: `Sostituiremo le nostre vecchie finestre con finestre a triplo vetro.`,
  we_will_run_weekly_workshops_bringing_older_people_together: `Organizzeremo seminari settimanali che riuniranno le persone anziane.`,
  how_will_you_achieve_this_outcome: `Come raggiungerai questo risultato?`,
  please_use_no_more_than_25_words_as_you_will_be_asked_to_describe_your_approach_on_the_next_screen: `Utilizza non più di 25 parole poiché ti verrà chiesto di descrivere il tuo approccio nella schermata successiva.`,
  enter_outcome: `Inserisci il risultato`,
  please_enter_numeric_value: `Inserisci un valore numerico`,
  expected_decision_date: `Data prevista per la decisione`,
  beneficiaries: `Beneficiari`,
  who_or_what_will_benefit_from_your_project: `Chi o cosa trarrà beneficio dal tuo progetto?`,
  who_are_the_social_beneficiaries: `Chi sono i beneficiari sociali?`,
  select_beneficiary_type: `Seleziona il tipo di beneficiario`,
  how_many_people_will_benefit: `Quante persone ne trarranno beneficio?`,
  direct_beneficiaries: `Beneficiari diretti`,
  enter_estimated_number: `Inserisci il numero stimato`,
  indirect_beneficiaries: `Beneficiari indiretti`,
  how_will_the_environment_benefit: `In che modo l’ambiente ne trarrà beneficio?`,
  for_example_species_of_new_plants_introduced_ppm_of_CO2_reduced_terrestrial_animals_protected: `Ad esempio, 10 specie di nuove piante introdotte, 10 ppm di CO2 ridotte, 10 animali terrestri protetti.`,
  select_type_title: `Seleziona Tipo`,
  select_sub_type: `Seleziona Sottotipo`,
  select_units: `Seleziona Unità`,
  your_environmental_beneficiaries_will_show_like_this_in_your_application_form: `I tuoi beneficiari ambientali verranno visualizzati in questo modo nel modulo di domanda:`,
  environmental_beneficiaries: `Beneficiari ambientali`,
  the_environmental_beneficiaries_drop_down_fields_enable_you_to_share_additional_details: `I campi a discesa dei beneficiari ambientali ti consentono di condividere ulteriori dettagli, ad esempio se stai sostenendo specie, habitat o edifici, piante o animali e quali azioni stai portando avanti. `,
  select_type_title_head: `Seleziona Tipo:`,
  choose_whether_your_project_supports_habitats_such_as_forests_or_woodlands: `Scegli se il tuo progetto supporta habitat, come foreste o boschi, specie, come piante o animali, o edifici, come scuole o edifici comunitari condivisi, come un municipio.`,
  select_sub_type_head: `Seleziona sottotipo:`,
  choose_the_type_of_habitat_species_or_building_you_are_supporting: `Scegli il tipo di habitat, specie o edificio che stai supportando. Ad esempio, seleziona l'acqua dolce se sostieni fiumi o laghi.`,
  select_action_head: `Seleziona Azione:`,
  choose_the_type_of_action_you_re_taking_to_support_the_species: `Scegli il tipo di azione che intendi intraprendere per sostenere la specie, l'habitat o l'edificio. Ad esempio, seleziona protetto se stai proteggendo specie in via di estinzione, ripristinato se stai rigenerando un habitat`,
  enter_amount_head: `Inserisci l'importo:`,
  for_species_estimate_how_many_plants_or_animals_you_re_supporting_through_your_project: `Per le specie, stima quante piante o animali sostieni attraverso il tuo progetto.`,
  for_habitats_estimate_how_many_habitats_you_re_supporting_number_or_the_total_area_in_hectares: `Per gli habitat, stima quanti habitat stai supportando (numero) o l'area totale (in ettari).`,
  for_buildings_estimate_how_many_buildings_you_re_supporting: `Per gli edifici, stima quanti edifici stai sostenendo (numero) o in che misura stai riducendo energia, acqua o gas serra (tonnellate di CO2 equivalenti (CO2e)).`,
  select_units_head: `Seleziona unità:`,
  number_is_an_estimate_of_the_total_number_of_habitats_species_or_buildings_you_plan_to_support: `Il numero è una stima del numero totale di habitat, specie o edifici che intendi supportare.`,
  hectares_is_an_estimate_of_the_total_area_of_a_habitat_youre_supporting: `Gli ettari sono una stima dell'area totale di un habitat che stai supportando.`,
  social_beneficiaries: `Beneficiari sociali`,
  select_the_type_of_beneficiaries_your_project_supports: `Seleziona il tipo di beneficiari supportati dal tuo progetto. Quindi stima il numero totale di beneficiari che prevedi di supportare tra tutti i tipi di beneficiari.`,
  direct_beneficiaries_head: `Beneficiari diretti:`,
  the_number_of_people_who_directly_benefit_from_your_opportunity: `Il numero di persone che beneficiano direttamente della tua opportunità.`,
  indirect_beneficiaries_head: `Beneficiari indiretti:`,
  the_number_of_people_whose_benefits_can_be_attributed_to_a_direct_beneficiary: `Il numero di persone i cui benefici possono essere attribuiti a un beneficiario diretto.`,
  for_example_if_your_project_supports_children_with_learning_disabilitie: `Ad esempio, se il tuo progetto sostiene 10 bambini con difficoltà di apprendimento, i beneficiari diretti sono i 10 bambini. I beneficiari indiretti sono le famiglie di quei bambini.`,
  habitats: `Habitat`,
  forest: `Foresta`,
  deserts: `Deserto`,
  mountains: `Montagna`,
  coastal: `Costiero`,
  marine: `Marino`,
  freshwater: `Acqua dolce`,
  polar: `Polare`,
  wetlands: `Zone umide`,
  rainforest: `Foresta pluviale`,
  arctic: `artico`,
  tundra: `Tundra`,
  restored: `Restaurato`,
  protected: `Protetto`,
  created: `Creato`,
  hectares: `Ettari`,
  established: `Stabilito`,
  benefitted: `Beneficiato`,
  terrestrial_animals: `Animali terrestri`,
  aquatic_animals: `Animali acquatici`,
  terrestrial_plants: `Piante terrestri`,
  aquatic_plants: `Piante acquatiche`,
  species: `Specie`,
  select_category: `Seleziona categoria`,
  select_sub_category: `Seleziona Sottocategoria`,
  please_add_at_least_one_outcome_under_selected_objectives: `Aggiungi almeno 1 risultato sotto gli obiettivi selezionati`,
  please_enter_your_approach_for_each_outcome: `Inserisci il tuo approccio per ciascun risultato`,
  create_n_manage_sharing: `Crea e gestisci la condivisione`,
  access_closing_date: `Data di chiusura dell'accesso`,
  please_choose_closing_date: `Scegli la data di chiusura`,
  newly_invited_users_will_receive_an_email_invitation: `Gli utenti appena invitati riceveranno un invito via email.`,
  existing_invited_users_will_not_be_notified_of_changes: ` Gli utenti invitati esistenti non verranno informati delle modifiche.`,
  update: `Aggiornamento`,
  user_already_exists: `L'utente esiste già`,
  verify_your_email: `Verifica la tua e-mail`,
  please_verify_your_email_to_receive_a_magic_link: `Verifica la tua email per ricevere un collegamento magico per accedere al tuo portale di feedback.`,
  emissions: `Emissioni`,
  greenhouse_gases: `Gas serra`,
  reduced: `Ridotto`,
  captured: `Catturato`,
  prevented: `Prevenuto`,
  tonnes_of_CO2_equivalents_C02e: `Tonnellate di CO2 equivalenti (C02e)`,
  additional_questions: `Domande aggiuntive`,
  required_documents: `Documenti richiesti`,
  document_name: `Nome del documento`,
  custom_question: `Domanda personalizzata?`,
  enter_answer: `Inserisci la risposta`,
  if_you_are_awarded_support_you_may_be_required_to_share_interim_Updates: `Se ti viene concesso il supporto, ti potrebbe essere richiesto di condividere aggiornamenti provvisori e un rapporto finale una tantum con l'azienda. Riceverai una notifica via email da BizGive se e quando questi sono dovuti.`,
  can_you_meet_the_required_submission_deadlines: `Riesci a rispettare le scadenze di presentazione richieste?`,
  based_on_the_estimated_start_and_finish_date_of_your_project: `In base alla data stimata di inizio e fine del tuo progetto, conferma che potresti rispettare le scadenze di presentazione riportate di seguito. Potrai aggiornare le date del tuo progetto se la tua domanda è appr`,
  interim_updates: `Aggiornamenti provvisori`,
  final_report: `Rapporto finale`,
  this_value_cannot_be_lower_than_the_amount_you_are_applying_for: `Questo valore non può essere inferiore all'importo richiesto`,
  what_is_an_interim_update: `Cos'è un aggiornamento provvisorio?`,
  an_update_required_by_the_company_on_the_progress_of_your_project: `Un aggiornamento richiesto dall'azienda sullo stato di avanzamento del tuo progetto.`,
  download_interim_update_report_template: `Scarica il modello di rapporto di aggiornamento provvisorio`,
  what_is_a_final_report: `Che cos'è un rapporto finale`,
  a_single_report_required_by_the_company_on_what_your_project_achieved_with_the_support_provided: `Un unico report richiesto dall'azienda su ciò che il tuo progetto ha realizzato con il supporto fornito.`,
  download_final_report_template: `Scarica il modello del rapporto finale`,
  how_will_i_know_when_an_interim_update_or_final_report_is_due: `Come faccio a sapere quando è previsto un aggiornamento intermedio o un rapporto finale?`,
  you_will_receive_an_email_notification_from_bizGive_when_the_deadline_is_approaching: `Riceverai una notifica via email da BizGive quando la scadenza si avvicina. Seguire le istruzioni contenute in queste e-mail per completare e inviare questi rapporti all'azienda.`,
  contact_details: `Dettagli di contatto`,
  after_submitting_your_application_you_will_receive_email_notifications_from_BizGive_on_its_status: `Dopo aver inviato la domanda, riceverai notifiche via email da BizGive sul suo stato.`,
  please_add_another_contact_in_case_of_your_absence: `Per favore aggiungi un altro contatto in caso di tua assenza.`,
  if_theyre_already_on_BizGive_select_their_name_below: `Se sono già su BizGive, seleziona il loro nome qui sotto:`,
  invite_a_colleague_to_join_by_entering_their_email_address_below: `Invita un collega a partecipare inserendo il suo indirizzo email qui sotto:`,
  select_user: `Seleziona Utente`,
  what_is_an_indicator: `Cos'è un indicatore?`,
  an_indicator_is_a_measure_of_progress: `Un indicatore è una misura del progresso. Include un obiettivo e tappe fondamentali per raggiungerlo. Ad esempio, il numero di persone che intendi aiutare e come questo aumenterà nel tempo.`,
  an_indicator_is_an_estimate: `Un indicatore è una stima, quindi non preoccuparti se i tuoi piani cambiano. Se la tua domanda viene approvata, ti verrà chiesto di aggiornare i tuoi indicatori.`,
  indicator_examples: `Esempi di indicatori`,
  no_of_people_gaining_a_new_skill_or_qualification: `N. di persone che acquisiscono una nuova abilità o qualifica`,
  no_of_workshops_hosted: `N. di workshop ospitati`,
  decrease_in_local_unemployment: `% di diminuzione della disoccupazione locale`,
  when_do_i_update_my_indicators: `Quando aggiorno i miei indicatori?`,
  if_your_application_is_approved: `Se la tua richiesta viene approvata, riceverai notifiche via email da BizGive quando ti verrà richiesto di aggiornare i tuoi indicatori.`,
  how_often_do_I_update_my_indicators: `Con quale frequenza aggiorno i miei indicatori?`,
  you_will_be_asked_to_update_your_indicators_at_the_same_time: `Ti verrà chiesto di aggiornare i tuoi indicatori contemporaneamente alla richiesta di inviare l'aggiornamento intermedio o il rapporto finale.`,
  measuring_progress: `Misurare il progresso`,
  objective_outcome_specific_indicators: `Indicatori specifici di obiettivo/risultato`,
  mandatory_title: `Obbligatorio`,
  about_your_project: `Informazioni sul tuo progetto`,
  your_request: `La tua richiesta`,
  planned_impact_title: `Impatto pianificato`,
  award_criteria: `Criteri di aggiudicazione`,
  step_1: `Passaggio 1`,
  step_2: `Passaggio 2`,
  step_3: `Passaggio 3`,
  step_4: `Passaggio 4`,
  step_5: `Passaggio 5`,
  submit_your_application: `Invia la tua domanda`,
  to_submit_your_application_you_must_read_and_agree_to_the_application: `Per inviare la domanda è necessario leggere e accettare la domanda`,
  terms_and_conditions: `Termini e Condizioni`,
  below: `sotto.`,
  please_note_you_will_not_be_able_to_edit_your_application_after_it_has_been_submitted_unless_requested_to_by_the_company_youre_applying_to: `Tieni presente che non potrai modificare la tua domanda dopo che è stata inviata, a meno che non venga richiesto dall'azienda per la quale ti stai candidando.`,
  by_submitting_this_application_you_will_be_sharing_your_application_user_details_and_ongoing_entity_profile_information_with_the_funder: `Inviando questa domanda condividerai la tua domanda, i dettagli dell'utente e le informazioni sul profilo dell'entità in corso con il finanziatore.`,
  enter_caption: `Inserisci la didascalia...`,
  impact_alignment: `Allineamento dell'impatto`,
  approve: `Approvare`,
  decline: `Declino`,
  requested_support: `Supporto richiesto`,
  total_request: `Richiesta totale`,
  total_project_budget: `Budget totale del progetto`,
  funder_contribution: `Contributo del finanziatore`,
  planned_expenditure: `Spesa pianificata`,
  additional_funding: `Finanziamenti aggiuntivi`,
  additional_funding_is_required_to_meet_the_total_opportunity_budget: `Sono necessari finanziamenti aggiuntivi per soddisfare il budget totale dell'opportunità`,
  where_will_additional_funds_be_sourced: `Da dove verranno reperiti i fondi aggiuntivi?`,
  has_this_funding_been_secured: `Questo finanziamento è stato garantito?`,
  can_this_project_go_ahead_without_additional_funding: `Questo progetto può andare avanti senza finanziamenti aggiuntivi?`,
  outputs: `Uscite`,
  you_must_select_yes_to_proceed: `È necessario selezionare Sì per procedere`,
  please_enter_the_dates_within_the_above_mentioned_limits: `Si prega di inserire le date entro i limiti sopra indicati`,
  at_least_one_checkbox_must_be_selected: `È necessario selezionare almeno una casella di controllo`,
  delete_confirmation: `Elimina conferma`,
  unchecking_this_box_will_delete_any_underlying_data_you_have_entered_for_this_objective_or_outcome: `Deselezionando questa casella verranno eliminati tutti i dati sottostanti inseriti per questo obiettivo o risultato.`,
  at_least_one_outcome_must_be_selected: `È necessario selezionare almeno 1 risultato`,
  please_select_at_least_one_objective: `Seleziona almeno 1 obiettivo`,
  project_timelines: `Tempistiche del progetto`,
  project_location: `Posizione del progetto`,
  pending_title: `In attesa di`,
  view_indicator: `Visualizza indicatore`,
  indicators_status_confirmation: `Conferma dello stato degli indicatori`,
  indicators_successfully_submitted: `Indicatori inviati con successo`,
  please_create_at_least_indicator_outcome: `Si prega di creare almeno un indicatore per risultato`,
  please_complete_n_delete_pending_indicators: `Completa o elimina gli indicatori in sospeso`,
  modal_will_be_closed_after_two_seconds: `La finestra modale verrà chiusa dopo due secondi`,
  please_enter_indicatorInterimActual: `Inserisci indicatoreInterimActual`,
  no_comments: `Non ci sono commenti`,
  enter_final_total: `Inserisci il totale finale`,
  milestone_date: `Data fondamentale`,
  accumulative_target: `Obiettivo cumulativo`,
  actuals: `Effettivi`,
  evidence: `Prova`,
  total_target: `Obiettivo totale`,
  please_enter_total_accumulative_target: `Inserisci il target cumulativo totale`,
  please_add_value_for_historic_milestone: `Aggiungi un valore per ogni pietra miliare storica`,
  cancel_uppercase: `CANCELLARE`,
  submit_uppercase: `INVIA`,
  press_submit_to_confirm: `Premi Invia per confermare l'inserimento. Tieni presente che questo sarà condiviso con`,
  confirmation: `Conferma`,
  your_donor_n_can_not_be_edited: `il tuo donatore e non può essere modificato`,
  indicator_name: `Nome dell'indicatore`,
  please_enter_indicator_name: `Inserisci il nome dell'indicatore`,
  main_focus: `Obiettivo principale`,
  social_n_beneficiaries: `Sociale/Beneficiari`,
  please_select_beneficiaries: `Seleziona i beneficiari`,
  please_enter_unit: `Inserisci l'unità`,
  how_will_you_measure_progress: `Come misurerai i progressi?`,
  starting_number_level_indicator: `Numero/livello iniziale del tuo indicatore`,
  if_you_do_not_know_this_then_enter_zero: `Se non lo sai, inserisci 0`,
  target_number_or_level_reach: `Numero target o livello da raggiungere`,
  target_we_aim_to_reach_is: `L'obiettivo che miriamo a raggiungere è`,
  from_starting_number_n_level: `dal numero/livello di partenza`,
  estimate_what_change_starting_para: `Facoltativo: stimare quale sarebbe il cambiamento nel numero/livello iniziale entro la fine della cronologia delle opportunità se non si intervenisse?`,
  your_total_effort_will_be: `Il tuo sforzo totale sarà`,
  taking_account_you_did_not_intervene: `tenendo conto di cosa accadrebbe se tu non intervenissi`,
  how_will_you_gather_evidence: `Come raccoglierai le prove?`,
  please_enter_details: `Inserisci i dettagli`,
  evidence_verification_method: `Metodo di verifica delle prove`,
  your_contribution: `Il tuo contributo`,
  measuring_your_impact: `Misurare il tuo impatto`,
  to_measure_the_progress_of_your_opportunity: `Per misurare l'avanzamento della tua opportunità, l'azienda ti ha chiesto di aggiungere indicatori. Gli indicatori consentono di fissare obiettivi stimati, con tappe fondamentali per raggiungerli.`,
  opportunity_indicators: `Indicatori di opportunità`,
  these_indicators_are_general_to_your_opportunity_or_entity: `Questi indicatori sono generali per la tua opportunità o entità. Fare clic su "Aggiungi" per crearli.`,
  these_indicators_support_the_specific_objectives_and_outcomes: `Questi indicatori supportano gli obiettivi e i risultati specifici della tua opportunità. Fare clic su "Aggiungi" per crearli`,
  describe_the_starting_situation: `Descrivi la situazione di partenza:`,
  describe_the_final_situation: `Descrivere la situazione finale target desiderata:`,
  describe_the_final_title_situation: `Descrivere la situazione finale desiderata:`,
  please_confirm_that_you_can_provide_any_of_following_evidence_items: `Conferma di essere in grado di fornire i seguenti elementi di prova`,
  starting_number_level_of_your_indicator: `Numero iniziale del tuo indicatore`,
  target_number_or_level_to_reach: `Numero target da raggiungere`,
  estimate_what_the_change_in_the_starting_number: `Facoltativo: stimare quale sarebbe il cambiamento nel numero/livello iniziale entro la fine della cronologia delle opportunità se non si intervenisse?`,
  the_target_we_aim_to_reach_is_employed_from_the_starting_number_level: `Il target che miriamo a raggiungere è Numero di occupati dal numero/livello di partenza`,
  your_total_impact_will_be_employed: `Il tuo impatto totale sarà impattoNumero di dipendenti`,
  your_final_absolute_change_is_impactNumber: `La tua ultima modifica assoluta è ImpactNumber`,
  your_final_relative_change_is_impactNumber: `La tua modifica relativa finale è ImpactNumber`,
  we_will_aim_for_sample_size_of_individuals: `Puntiamo a un campione di 20 individui...`,
  restrict_applications_to_within_certain_radius_of_this_location: `Limitare le applicazioni entro un certo raggio da questa posizione?`,
  enter_number: `Inserisci il numero`,
  biannually: `Semestralmente`,
  please_select_your_impact_strategy: `Seleziona la tua strategia di impatto`,
  reporting_requirements: `Requisiti di segnalazione`,
  starting: `Di partenza`,
  create_indicator: `Crea indicatore`,
  optional_title: `Opzionale`,
  estimate_what_the_level_would_be: `Stimare quale sarebbe il cambiamento nel numero iniziale entro la data di fine del progetto se non intervenissi? (aggiungere il segno +/-)`,
  this_value_cannot_be_more_than_the_amount_you_are_applying_for: `Questo valore non può essere superiore all'importo richiesto`,
  you_must_apply_for_100_percentage_of_the_total_project_cost: `È necessario richiedere il 100% del costo totale del progetto`,
  please_save_a_location: `Per favore salva una posizione`,
  i_agree: `Sono d'accordo`,
  project_running_dates: `Date di esecuzione dei progetti`,
  donations_required_before: `Donazioni richieste prima`,
  add_programme: `Aggiungi programma`,
  budget_end_date: `Data di fine budget`,
  application_window: `Finestra dell'applicazione`,
  choose_either_option: `Scegli una delle due opzioni:`,
  copy_an_existing_programme: `Copia un programma esistente`,
  create_a_new_programme: `Creare un nuovo programma`,
  what_is_the_name_of_your_programme: `Come si chiama il tuo programma?`,
  what_is_the_area_of_impact: `Qual è la zona di impatto?`,
  projects_or_impact_must_be_within: `I progetti o l'impatto devono rientrare:`,
  a_custom_area: `Un'area personalizzata`,
  an_administrative_boundary_eg_a_council_area_or_country: `Un confine amministrativo, ad es. un'area comunale o un paese.`,
  a_certain_distance_from_a_point: `Una certa distanza da un punto.`,
  click_on_the_map_to_start_drawing_your_area: `Clicca sulla mappa per iniziare a disegnare la tua zona, fai doppio clic per completarla. Se necessario, puoi eliminarlo dall'opzione del nome dell'area sotto la mappa facendo clic sull'icona di eliminazione accanto a destra del`,
  use_the_search_box_to_find_administrative_boundaries: `Utilizza la casella di ricerca per trovare i confini amministrativi. Visualizza un confine facendo clic sul nome, seleziona un confine facendo clic su "Scegli". Elimina aree o modifica nomi dalla sezione del nome dell'area sotto il `,
  click_on_the_map_to_add_a_point: `Fai clic sulla mappa per aggiungere un punto, quindi inserisci un raggio consentito di seguito e premi "Genera area" per mostrare l'area sulla mappa. Ricomincia cliccando sulla mappa per aggiungere un nuovo punto.`,
  what_is_the_area_called: `Come si chiama la zona?`,
  programme_details: `Dettagli del programma`,
  write_a_short_summary_of_your_programme: `Scrivi un breve riassunto del tuo programma`,
  write_a_longer_description: `Scrivi una descrizione più lunga`,
  do_you_wish_to_share_any_supporting_material: `Desideri condividere materiale di supporto?`,
  select_all_options: `Seleziona tutte le opzioni`,
  indicators: `Indicatori`,
  details: `Dettagli`,
  programme_support: `Supporto al programma`,
  what_support_can_you_offer: `Che supporto puoi offrire?`,
  what_is_your_budget: `Qual è il tuo budget?`,
  make_this_budget_amount_visible_in_your_programme_as_an_estimated_budget: `Rendi visibile l'importo del budget nel tuo programma come "Budget stimato"`,
  is_there_a_limit_donation_amount_per_project: `Esiste un importo limite per la donazione per progetto?`,
  projects_must_be_fully_funded_by_you_without_additional_third_party_funding: `I progetti devono essere interamente finanziati da te senza ulteriori finanziamenti da parte di terzi`,
  does_this_budget_recur: `Questo budget è ricorrente?`,
  per_project: `Per progetto`,
  no_it_is_fixed: `No, è risolto.`,
  yes_annual_starting_on: `Sì, annuale a partire dal:`,
  please_include_in_your_invoice_the_following_details: `Si prega di includere nella fattura i seguenti dettagli...`,
  share_any_invoice_instructions_for_approved_grantees_to_view: `Condividi eventuali istruzioni sulla fattura affinché i beneficiari approvati possano visualizzarle`,
  do_you_want_to_upload_an_invoice_template_for_approved_applicants_to_use: `Desideri caricare un modello di fattura che i candidati approvati possano utilizzare?`,
  what_type_of_volunteering_can_you_offer: `Che tipo di volontariato potete offrire?`,
  what_skilled_volunteering_is_available: `Quale volontariato qualificato è disponibile?`,
  start_date: `Data di inizio`,
  end_date: `Data di fine`,
  general: `Generale`,
  skilled: `Abile`,
  skill: `Abilità`,
  number_of_item_service: `Numero (dell'articolo/servizio)`,
  item_service_description: `Descrizione articolo/servizio`,
  what_type_of_in_kind_support_can_you_offer: `Che tipo di supporto in natura puoi offrire?`,
  timelines: `Cronologia`,
  when_are_you_accepting_applications: `Quando accetti le candidature?`,
  a_date_range: `Un intervallo di date`,
  ongoing: `In corso`,
  when_are_application_decisions_made: `Quando vengono prese le decisioni relative alla domanda?`,
  periodically: `Periodicamente`,
  when_do_you_expect_to_make_donations: `Quando prevedi di effettuare le donazioni?`,
  do_you_want_to_restrict_project_timelines: `Vuoi limitare le tempistiche del progetto?`,
  projects_must_start_within: `I progetti devono iniziare all'interno`,
  projects_must_not_be_longer_than: `I progetti non devono avere una durata superiore a`,
  months: `mesi`,
  eligible_entities: `Entità idonee`,
  what_type_of_entity_is_able_to_apply_to_your_programme: `Che tipo di entità può candidarsi al vostro programma?`,
  please_select_all_that_apply_below: `Seleziona tutto ciò che si applica di seguito.`,
  uk: `Regno Unito`,
  international: `Internazionale`,
  applicants_must_agree_to_these_before_applying: `I candidati devono accettarli prima di presentare domanda`,
  entity_project_must_be: `L'entità/progetto deve essere...`,
  application_questions: `Domande sull'applicazione`,
  do_you_want_to_add_any_custom_application_questions: `Vuoi aggiungere domande sull'applicazione personalizzata?`,
  word_limit: `Limite di parole`,
  question: `Domanda`,
  please_enter_your_application_terms_and_conditions: `Inserisci i termini e le condizioni della tua richiesta`,
  we_ask_all_applicants_to_approve_this_before_submitting_their_application: `Chiediamo a tutti i candidati di approvarlo prima di presentare la domanda.`,
  please_enter_a_link_to_your_privacy_policy: `Inserisci un collegamento alla tua informativa sulla privacy`,
  we_ask_all_applicants_to_acknowledge_this_before_submitting_their_application: `Chiediamo a tutti i candidati di prenderne atto prima di presentare la domanda.`,
  measuring_impact: `Misurare l'impatto`,
  when_do_you_want_to_receive_interim_updates: `Quando vuoi ricevere gli "Aggiornamenti provvisori"?`,
  recurring_to_project_dates: `Ricorrente alle date del progetto`,
  not_required: `Non richiesto`,
  every: `Ogni`,
  days_between_project_start_and_end_dates: `Giorni tra le date di inizio e di fine del progetto`,
  when_do_you_want_to_receive_a_final_report: `Quando vuoi ricevere un "Rapporto finale"?`,
  relative_to_project_dates: `Relativo alle date del progetto`,
  days_after_the_project_end_date: `Giorni dopo la data di fine del progetto`,
  are_there_any_additional_questions_you_would_like_to_ask_in_the_final_report: `Ci sono ulteriori domande che vorresti porre nel rapporto finale?`,
  do_you_want_additional_legal_terms_for_entities_to_accept_on_submission_of_reports_to_you: `Desideri ulteriori termini legali che le entità accettino al momento dell'invio delle segnalazioni a te?`,
  programme_administration: `Amministrazione del programma`,
  internal_approval_steps: `Passaggi di approvazione interna`,
  approval_step: `Fase di approvazione`,
  voting: `Voto`,
  scoring_category: `Categoria di punteggio`,
  create_the_categories_that_you_would_like_to_evaluate_applications_against: `Crea le categorie rispetto alle quali desideri valutare le candidature, ad es. “Rapporto qualità-prezzo” o “Impatto totale”`,
  insert: `Inserire`,
  scoring_category_options: `Opzioni della categoria di punteggio`,
  detail_the_category_options_available_to_be_selected_for_the_above_categories: `Dettagliare le opzioni di categoria disponibili per essere selezionate per le categorie di cui sopra con il "valore numerico" di ciascuna opzione, in modo da poter calcolare un punteggio finale. Facoltativamente puoi anche includere una descrizione`,
  list_the_scoring_category_options_with_a_value_and_an_optional_description: `Elenca le opzioni della categoria di punteggio con un valore e una descrizione facoltativa. Ad esempio, il valore potrebbe essere "1" e la descrizione "Basso" o il valore "3" e la descrizione "Alto".`,
  numerical_value: `Valore numerico`,
  optional_description: `Descrizione facoltativa`,
  who_will_manage_this_programme: `Chi gestirà questo programma?`,
  managers_can_edit_the_programme_interact_with_applicants_approve_applications_and_receive_related_email_notifications: `I manager possono modificare il programma, interagire con i candidati, approvare le domande e ricevere le relative notifiche via email.`,
  who_can_view_this_programme: `Chi può visualizzare questo programma`,
  viewers_can_view_the_programme_and_applications_but_not_edit_the_programme: `Gli spettatori possono visualizzare il programma e le candidature ma non modificare il programma, interagire con i candidati, approvare le candidature né ricevere le relative notifiche e-mail.`,
  programme_visibility: `Visibilità del programma`,
  bizGive_open: `BizGive (Aperto)`,
  any_charity_signed_up_to_bizGive_can_view_and_apply_to_your_programme: `Qualsiasi ente di beneficenza iscritto a BizGive può visualizzare e presentare domanda per il tuo programma.`,
  bizGive_invite_only: `BizGive (solo su invito)`,
  only_charities_you_invite_to_apply_to_your_programme_can_view_it: `Solo gli enti di beneficenza che inviti a presentare domanda per il tuo programma possono visualizzarlo.`,
  public_open: `Pubblico (aperto)`,
  your_programme_will_have_its_own_link_and_branded_landing_page_on_bizGive: `Il tuo programma avrà il proprio collegamento e una pagina di destinazione personalizzata su BizGive, quindi potrai condividerlo ovunque al di fuori della piattaforma. Anche qualsiasi ente di beneficenza iscritto a BizGive potrà visualizzare e presentare domanda.`,
  public_invite_only: `Pubblico (solo su invito)`,
  your_programme_will_have_its_own_link_and_branded_landing_page_on_bizGive_invite_them_to_apply: `Il tuo programma avrà il proprio collegamento e una pagina di destinazione personalizzata su BizGive, quindi potrai condividerlo ovunque al di fuori della piattaforma. Non sarà visibile agli enti di beneficenza iscritti a BizGive, a meno che tu non sia presente`,
  add_a_custom_programme_url: `Aggiungi un URL del programma personalizzato`,
  publish_your_programme: `Pubblica il tuo programma`,
  this_will_make_your_programme_visible_as_per_your_visibility_settings: `Ciò renderà il tuo programma visibile secondo le tue impostazioni di visibilità.`,
  you_can_still_edit_all_details_of_the_programmes_after_publishing: `Puoi comunque modificare tutti i dettagli dei programmi dopo la pubblicazione.`,
  required_document_name: `Nome documento obbligatorio`,
  change: `Modifica`,
  number_of_days: `Numero di giorni`,
  programme_approval: `Approvazione del programma`,
  there_must_be_at_least_1_votingScoreCriteria_added: `È necessario aggiungere almeno 1 criterio di punteggio di voto`,
  there_must_be_at_least_1_votingCriteriaOptions_added: `Deve essere aggiunto almeno 1 criterio di voto`,
  publish: `Pubblicare`,
  confirm: `Confermare`,
  project_timeline: `Cronologia del progetto`,
  company: `Azienda`,
  this_programme_is_closing_in_number_days: `Questo programma terminerà tra numero giorni`,
  this_programme_is_now_closed: `Questo programma è ora chiuso`,
  the_application_window_is: `La finestra dell'applicazione è`,
  login_or_signup_into_bizGive_to_discover_new_funding_programmes: `Accedi o registrati a BizGive per scoprire nuovi programmi di finanziamento.`,
  discover_more_programmes: `Scopri altri programmi`,
  end: `FINE`,
  to_apply_to_the: `Per candidarsi al`,
  log_in_or_sign_up_to_create_your_free_bizGive_account: `Accedi o registrati per creare il tuo account BizGive gratuito.`,
  if_youre_new_to_BizGive_create_an_organisation_profile: `Se sei nuovo su BizGive, crea un profilo dell'organizzazione.`,
  complete_your_application_to_the_programme: `Completa la tua candidatura al programma.`,
  receive_alerts_when_action_is_required_or_a_funding_decision_is_made: `Ricevi avvisi quando è necessaria un'azione o viene presa una decisione di finanziamento.`,
  apply_to_other_programmes_from_the_discover_section: `Candidati ad altri programmi dalla sezione Scopri.`,
  entity_location: `Posizione dell'entità`,
  which_country_must_entities_be_located_in_leave_blank_if_any_are_accepted: `In quale Paese devono avere sede le entità? Lasciare vuoto se ne vengono accettati`,
  search_country: `Cerca Paese`,
  already_registered: `Già registrato?`,
  login_here: `Accedi qui`,
  application_to: `Applicazione a`,
  continue_application: `Continua l'applicazione`,
  delete_application: `Elimina applicazione`,
  edit_resubmit: `Modifica e invia nuovamente`,
  withdraw: `Ritirare`,
  this_will_withdraw_your_application_and_return_it_to_a_pending_state: `Ciò ritirerà la tua domanda e la riporterà allo stato "In sospeso".`,
  this_will_delete_your_application_and_saved_data: `Ciò eliminerà l'applicazione e i dati salvati.`,
  withdraw_application: `Ritirare la domanda`,
  send: `Inviare`,
  enable_editing_of_application: `Abilita la modifica dell'applicazione`,
  application_editing_enabled: `Modifica dell'applicazione abilitata`,
  pre_approve: `Pre-approvazione`,
  withdraw_pre_approval: `Ritirare la pre-approvazione`,
  confirm_approval: `Conferma approvazione`,
  grant_award: `Premio Sovvenzione`,
  please_confirm_you_wish_to_approve_this_application: `Conferma che desideri approvare questa richiesta.`,
  share_a_message: `Condividi un messaggio:`,
  confirm_decline: `Conferma rifiuto`,
  please_explain_your_decision_to_the_applicant: `Si prega di spiegare la propria decisione al richiedente`,
  application_related: `Relativo all'applicazione`,
  entity_related: `Relativo all'entità`,
  programme_related: `Relativo al programma`,
  add_a_message: `Aggiungi un messaggio`,
  there_are_items_we_cannot_fund: `Ci sono elementi che non possiamo finanziare`,
  the_impact_of_your_project_is_not_clear_enough: `L'impatto del tuo progetto non è abbastanza chiaro`,
  the_impact_of_your_project_is_lower_relative_to_other_applications: `L'impatto del tuo progetto è inferiore rispetto ad altre applicazioni.`,
  your_entity_does_not_meet_our_criteria: `La tua entità non soddisfa i nostri criteri`,
  your_project_does_not_align_closely_enough_with_our_objectives: `Il tuo progetto non è sufficientemente in linea con i nostri obiettivi`,
  other_projects_more_closely_aligned_with_our_objectives: `Altri progetti più strettamente allineati ai nostri obiettivi`,
  your_project_did_not_fully_meet_our_eligibility_criteria: `Il tuo progetto non ha soddisfatto pienamente i nostri criteri di idoneità`,
  funding_in_this_round_has_already_been_disbursed_to_similar_projects: `I finanziamenti in questa tornata sono già stati erogati a progetti simili`,
  please_select_an_decline_option_or_write_a_message: `Seleziona un'opzione di rifiuto o scrivi un messaggio`,
  confirm_pre_approval: `Conferma la pre-approvazione`,
  please_confirm_your_pre_approval: `Si prega di confermare la pre-approvazione.`,
  please_confirm_your_approval: `Per favore conferma la tua approvazione.`,
  pre_approving_will_not_notify_the_applicant: `La pre-approvazione non avviserà il richiedente.`,
  approving_will_not_notify_the_applicant: `L'approvazione non avviserà il richiedente.`,
  internal_review: `Revisione interna`,
  entity_history: `Storia dell'entità`,
  you_have_received_an_application_from_this_entity_before: `Hai già ricevuto una domanda da questa entità.`,
  approval: `Approvazione`,
  approved_by: `Approvato da`,
  confirm_step_completion: `Conferma il completamento del passaggio`,
  please_confirm_this_step_has_been_completed: `Conferma che questo passaggio è stato completato.`,
  total_score: `Punteggio totale`,
  voters: `Elettori`,
  category_totals: `Totali di categoria`,
  name: `Nome`,
  telephone: `Telefono`,
  email: `E-mail`,
  category_score: `Punteggio della categoria`,
  date: `Data`,
  my_vote: `Il mio voto`,
  saved: `Salvato`,
  vote: `Votare`,
  value_for_money: `Rapporto qualità-prezzo`,
  total_impact: `Impatto totale`,
  total: `Totale`,
  comments: `Commenti`,
  edit: `Modificare`,
  what_are_your_overall_comments: `Quali sono i tuoi commenti generali?`,
  select_score: `Seleziona Punteggio`,
  please_select_at_least_one_checkbox: `Seleziona almeno una casella di controllo`,
  create_your_profile: `Crea il tuo profilo`,
  on_the_following_screens_you_will_be_asked_to_complete_a_profile_of_your_entity: `Nelle schermate seguenti ti verrà chiesto di completare un profilo della tua entità.`,
  how_your_profile_is_used: `Come viene utilizzato il tuo profilo`,
  once_your_profile_is_complete_it_will_be_automatically_attached_to_any_application_you_submit_through_bizGive: `Una volta completato il tuo profilo, verrà automaticamente allegato a qualsiasi domanda inviata tramite BizGive.`,
  companies_and_bizGive_use_your_profile_to_perform_background_due_diligence_checks_on_your_organisation_it_is_only_visible_to_companies_you_apply_to: `Le aziende e BizGive utilizzano il tuo profilo per eseguire controlli di due diligence sulla tua organizzazione. È visibile solo alle aziende per le quali ti candidi.`,
  once_complete_you_will_be_able_to_apply_to_as_many_company_programmes_as_you_re_eligible_for_from_the_discover_tab: `Una volta completato, potrai fare domanda per tutti i programmi aziendali a cui hai diritto dalla scheda "Scopri".`,
  profile_guidance: `Guida al profilo`,
  saves_your_data_and_moves_you_to_the_next_screen_your_answers_will_automatically_be_saved_unless_you_have_an_internet_connectivity_issue: `salva i tuoi dati e ti sposta alla schermata successiva. Le tue risposte verranno salvate automaticamente, a meno che tu non abbia un problema di connettività Internet.`,
  saves_your_data_and_logs_you_out_of_bizGive: `salva i tuoi dati e ti disconnette da BizGive. Potrai continuare il tuo profilo quando effettuerai nuovamente l'accesso. Dovrai compilare tutti i campi obbligatori per "Salva ed esci" (puoi inserire valori casuali`,
  entity_details: `Dettagli dell'entità`,
  name_n_address: `Nome e indirizzo`,
  do_you_have_a_different_trading_name_or_display_name: `Hai un nome commerciale o un nome visualizzato diverso?`,
  legal_structure: `Struttura giuridica`,
  what_is_your_legal_structure: `Qual è la vostra struttura giuridica?`,
  unregistered_organisation: `Organizzazione non registrata`,
  what_is_your_registration_number: `Qual è il tuo numero di registrazione?`,
  this_is_your_registration_number_with_the_relevant_regulator_of_your_entity: `Questo è il tuo numero di registrazione presso l'ente regolatore competente della tua entità.`,
  please_share_a_link_to_your_online_registration: `Per favore condividi un link alla tua registrazione online`,
  this_is_a_link_to_your_profile_on_the_regulators_website: `Questo è un collegamento al tuo profilo sul sito web dell’autorità di regolamentazione.`,
  please_upload_a_copy_of_your_governing_document: `Si prega di caricare una copia dei documenti regolamentari`,
  these_are_not_available: `Questi non sono disponibili`,
  please_share_a_reason: `Per favore condividi un motivo`,
  please_upload_a_copy_of_your_governing_documents: `Si prega di caricare una copia dei documenti regolamentari`,
  for_example_your_trust_deed: `Ad esempio, il tuo atto fiduciario.`,
  please_upload_a_copy_of_your_most_recent_annual_accounts: `Carica una copia dei tuoi conti annuali più recenti`,
  for_example_your_Articles_of_association: `Ad esempio, il tuo Statuto.`,
  please_upload_a_copy_of_your_constitution_trust_deed_or_rules: `Carica una copia della tua costituzione, atto fiduciario o regole`,
  please_upload_a_copy_of_your_registration_documents_or_most_recent_annual_accounts: `Carica una copia dei documenti di registrazione o dei conti annuali più recenti`,
  entity_types: `Tipi di entità`,
  registered_with_the_relevant_national_or_regional_regulatory_authority_for_example_the_charity_commission_in_the_uk: `Registrato presso l'autorità di regolamentazione nazionale o regionale competente. Ad esempio, la Charity Commission nel Regno Unito.`,
  community_interest_company_uk_only: `Società di interesse comunitario (solo Regno Unito)`,
  registered_with_companies_house: `Registrato presso la Companies House. Una forma speciale di società a responsabilità limitata non di beneficenza che esiste per avvantaggiare una comunità o perseguire uno scopo sociale. Molte imprese sociali sono CIC.`,
  a_type_of_charity_run_by_a_small_group_of_people_known_as_trustees: `Un tipo di ente di beneficenza gestito da un piccolo gruppo di persone conosciute come fiduciari. Nel Regno Unito, un trust deve registrarsi presso la Charity Commission quando il suo reddito annuo supera le 5.000 sterline.`,
  an_educational_institution_such_as_a_university_or_school: `Un istituto di istruzione come un'università o una scuola.`,
  an_entity_that_is_not_registered_or_regulated_for_example_clubs_societies_and_small_community_groups: `Un'entità che non è registrata o regolamentata. Ad esempio, club, società e piccoli gruppi comunitari.`,
  a_type_of_charitable_organisation_registered_as_a_company_limited_by_guarantee: `Un tipo di organizzazione di beneficenza registrata come società a responsabilità limitata o altra struttura aziendale senza scopo di lucro. Nel Regno Unito, sono registrati presso la Companies House come società a responsabilità limitata da Gu`,
  organisations_that_are_responsible_for_the_provision_of_public_services: `Enti responsabili della fornitura di servizi pubblici.`,
  trustees: `Amministratori`,
  please_provide_the_name_of_your_trustees_or_directors: `Si prega di fornire il nome dei vostri fiduciari o direttori.`,
  a_minimum_of_two_is_required_only_1_is_required_if_you_are_a_uk_cic: `È richiesto un minimo di 2. È richiesto solo 1 se sei un CIC del Regno Unito.`,
  where_are_you_able_to_run_your_projects: `Dove puoi portare avanti i tuoi progetti?`,
  based_on_your_selections_we_will_be_able_to_recommend_relevant_new_funding_programmes_to_you: `In base alle tue selezioni, saremo in grado di consigliarti nuovi programmi di finanziamento pertinenti.`,
  countries_of_operation: `Paesi di operazione`,
  within_your_selected_countries_can_you_run_projects_nationwide_or_in_specific_locations_only: `All'interno dei paesi selezionati, potete gestire progetti a livello nazionale o solo in località specifiche?`,
  nationwide: `A livello nazionale`,
  specific_locations: `Posizioni specifiche`,
  please_describe_what_your_organisation_does: `Descrivi cosa fa la tua organizzazione`,
  please_provide_a_brief_overview_of_your_groups_purpose_aims_and_objectives: `Fornisci una breve panoramica dello scopo, degli scopi e degli obiettivi del tuo gruppo.`,
  social_media: `Social media`,
  please_share_a_link_to_your_website: `Per favore condividi un link al tuo sito web`,
  if_applicable_please_share_your_social_media_links: `Se applicabile, condividi i tuoi link ai social media`,
  please_add_your_entity_logo: `Aggiungi il logo della tua entità`,
  your_profile_is_complete: `Il tuo profilo è completo`,
  you_can: `Puoi`,
  edit_title_caption: `'Modificare'`,
  your_profile_at_any_point_by_clicking_into: `il tuo profilo in qualsiasi momento facendo clic su "La mia organizzazione" > "Profilo" > "Modifica"`,
  what_happens_next: `Cosa succede dopo?`,
  start_your_application: `Avvia la tua applicazione`,
  if_you_accessed_bizGive_via_a_company_programme: `Se hai effettuato l'accesso a BizGive tramite un programma aziendale, fai clic su "Applica" per avviare il modulo di domanda.`,
  discover_company_programmes: `Scopri i programmi aziendali`,
  click_discover_to_view_and_apply_to_live_company_support_programmes: `Fai clic su "Scopri" per visualizzare e candidarti ai programmi di supporto aziendale in tempo reale.`,
  enter_url: `Inserisci l'URL`,
  please_upload_documentation: `Si prega di caricare la documentazione`,
  council_or_government_linked_entity: `Consiglio o entità collegata al governo`,
  locations: `Posizioni`,
  specific_locations_within_each_country: `Posizioni specifiche all'interno di ciascun paese`,
  entity_type: `Tipo di entità`,
  legal_name: `Nome legale`,
  governing_documents: `Documenti governativi`,
  operating_location: `Sede operativa`,
  nationally_in_the_following_countries: `A livello nazionale nei seguenti paesi:`,
  locally_in_the_following_countries: `Localmente nei seguenti paesi:`,
  not_available: `Non disponibile`,
  registration_number: `Numero di registrazione`,
  trading_name: `Nome commerciale`,
  web_uri: `URI Web`,
  registration_profile_url: `URL del profilo di registrazione`,
  discover_funding_opportunities: `Scopri le opportunità di finanziamento`,
  available_programmes_filtered_by_your_entitys_area_of_operation: `Programmi disponibili Filtrati in base all'area operativa della tua entità:`,
  change_here: `Cambia qui`,
  programme: `Programma`,
  applications_accepted: `Domande accettate`,
  decision_made: `Decisione presa`,
  location: `Posizione`,
  action: `Azione`,
  your_entity_type_is_not_supported_by_this_programme: `Il tuo tipo di entità non è supportato da questo programma.`,
  please_click_ok_and_view_the_permitted_entities_in_the_programme_review_page: `Fai clic su "OK" e visualizza le entità consentite nella pagina di revisione del programma.`,
  content: `Contenuto`,
  select_programme: `Seleziona Programma`,
  select_report_type: `Seleziona Tipo di rapporto`,
  enter_start_date: `Inserisci la data di inizio`,
  enter_end_date: `Inserisci la data di fine`,
  report: `Rapporto`,
  overdue: `In ritardo`,
  view_report: `Visualizza rapporto`,
  start_report: `Avvia rapporto`,
  complete_report: `Rapporto completo`,
  add_your_profile_picture: `Aggiungi la tua immagine del profilo`,
  project: `Progetto`,
  registration_website: `Sito Web di registrazione`,
  outside_of_impact_area: `Al di fuori dell'area di impatto`,
  this_interim_update_is_for: `Questo aggiornamento provvisorio è per`,
  interim_update_deadline: `Scadenza aggiornamento provvisorio`,
  form_guidance: `Guida al modulo`,
  in_the_form_you_will_be_asked_to_share_details_of_the_project_you_received_funding_for: `Nel modulo ti verrà chiesto di condividere i dettagli del progetto per il quale hai ricevuto il finanziamento.`,
  to_access_a_saved_interim_update_click_into_impact: `Per accedere a un aggiornamento temporaneo salvato: fare clic su Impatto > Contenuto >`,
  to_access_a_saved_interim_update_click_into_impact_content: `Per visualizzare un aggiornamento provvisorio inviato: fare clic su Impatto > Contenuto > Visualizza rapporto`,
  interim_update: `Aggiornamento provvisorio`,
  below_is_the_support_you_requested_from_the_company_in_your_application: `Di seguito è riportato il supporto che hai richiesto all'azienda nella tua domanda.`,
  how_have_you_used_the_support_provided_so_far: `Come avete utilizzato il supporto fornito finora?`,
  are_there_any_changes_to_your_planned_expenditure_and_if_so_why: `Sono state apportate modifiche alle spese pianificate e, se sì, perché?`,
  are_there_any_changes_to_your_estimated_completion_date_and_if_so_why: `Sono state apportate modifiche alla data di completamento stimata e, in caso affermativo, perché?`,
  please_email_bizGive: `Si prega di inviare un'e-mail a BizGive`,
  if_there_is_a_substantial_change_to_your_completion_date_and_we_will_ensure_the_deadline_for_your_final_report_is_update: `se c'è una modifica sostanziale alla data di completamento e garantiremo che la scadenza per il rapporto finale sia aggiornata.`,
  share_images: `Condividi contenuti multimediali`,
  please_upload_images_to_bring_your_project_to_life_this_significantly_increases_the_likelihood_of_the_company_sharing_your_content: `Carica i media per dare vita al tuo progetto. Ciò aumenta significativamente la probabilità che l’azienda condivida i tuoi contenuti.`,
  sends_your_form_to_the_company: `invia il tuo modulo all'azienda. Questo pulsante viene visualizzato nella schermata finale del modulo.`,
  submit_your_report: `Invia la tua segnalazione`,
  i_have_read_and_agree_to_the_above_terms: `Ho letto e accetto i termini di cui sopra.`,
  please_confirm_that_all_necessary_copyrights_and_acknowledgements_have_been_added: `Conferma che siano stati aggiunti tutti i diritti d'autore e i riconoscimenti necessari.`,
  i_confirm_that_all_necessary_copyrights_and_acknowledgements_have_been_added: `Confermo che sono stati aggiunti tutti i diritti d'autore e i riconoscimenti necessari.`,
  final_report_deadline: `Scadenza per la relazione finale`,
  please_press_add_to_save_the_invited_user: `Premi Aggiungi per salvare l'utente invitato`,
  inputs: `Ingressi`,
  did_any_of_your_plans_change: `Qualcuno dei tuoi piani è cambiato?`,
  please_select_and_enter_your_final_inputs: `Seleziona e inserisci i tuoi input finali`,
  please_update_your_expenditure: `Si prega di aggiornare le spese`,
  please_update_the_items_or_services_you_used: `Aggiorna gli articoli o i servizi che hai utilizzato`,
  please_update_the_volunteering_support_you_used: `Aggiorna il supporto di volontariato che hai utilizzato`,
  below_are_the_outputs_you_shared_in_your_application: `Di seguito sono riportati gli output che hai condiviso nella tua applicazione.`,
  did_your_outputs_change: `I tuoi risultati sono cambiati?`,
  please_update_your_outputs: `Aggiorna i tuoi risultati`,
  your_outputs_will_show_like_this_in_your_report: `I tuoi risultati verranno visualizzati in questo modo nel tuo rapporto:`,
  i_acknowledge_the: `Riconosco il`,
  below_are_the_beneficiaries_you_shared_in_your_application: `Di seguito sono riportati i beneficiari che hai condiviso nella tua domanda.`,
  did_your_social_beneficiary_types_change: `La tipologia dei tuoi beneficiari sociali è cambiata?`,
  please_update_your_social_beneficiary_types: `Aggiorna i tipi di beneficiari sociali`,
  did_your_social_beneficiary_numbers_change: `Il numero dei tuoi beneficiari sociali è cambiato?`,
  please_update_your_social_beneficiary_numbers: `Si prega di aggiornare i numeri dei beneficiari sociali`,
  did_your_environmental_beneficiaries_change: `I tuoi beneficiari ambientali sono cambiati?`,
  please_update_your_environmental_beneficiaries: `Si prega di aggiornare i beneficiari ambientali`,
  below_are_the_objectives_and_outcomes_you_shared_in_your_application: `Di seguito sono riportati gli obiettivi e i risultati che hai condiviso nella tua candidatura.`,
  objectives_n_outcomes: `Obiettivi e risultati`,
  were_you_successful_in_achieving_your_objectives_and_outcomes: `Sei riuscito a raggiungere i tuoi obiettivi e risultati?`,
  inputs_n_outputs: `Ingressi e uscite`,
  case_studies: `Casi di studio`,
  preview_n_submit: `Anteprima e invio`,
  impact_measures: `Misure di impatto`,
  the_company_has_requested_you_to_add_indicators_to_measure_the_progress_of_your_project: `L'azienda ti ha richiesto di aggiungere indicatori per misurare lo stato di avanzamento del tuo progetto.`,
  general_indicators: `Indicatori generali`,
  these_indicators_are_general_to_your_opportunity_or_entity_please_click_add_to_create_them: `Questi indicatori sono generali per la tua opportunità o entità. Fare clic su "Aggiungi" per crearli.`,
  indicator: `Indicatore`,
  required: `Necessario?`,
  target: `Bersaglio`,
  final_title: `Finale`,
  status: `Stato`,
  project_indicators: `Indicatori di progetto`,
  the_indicators_below_are_linked_to_your_selected_objectives_and_outcomes_please_click_add_to_create_them: `Gli indicatori seguenti sono collegati agli obiettivi e ai risultati selezionati. Fare clic su "Aggiungi" per crearli.`,
  objective: `Obiettivo`,
  outcome: `Risultato`,
  achieved: `Raggiunto`,
  your_absolute_impact_is: `Il tuo impatto assoluto è ImpactNumber`,
  your_relative_impact_is: `Il tuo impatto relativo è ImpactNumber`,
  case_studies_and_media: `Casi di studio e media`,
  case_studies_and_images_increase_the_likelihood_of_the_company_sharing_your_project_where_possible_please_share_a_case_study_and_at_least_one_image: `Casi di studio e immagini aumentano la probabilità che l'azienda condivida il tuo progetto. Ove possibile, condividi un caso di studio e almeno un'immagine.`,
  add_case_study: `Aggiungi caso di studio`,
  add_images: `Aggiungi contenuti multimediali`,
  case_study_name: `Nome del caso di studio`,
  what_impact_did_your_project_have: `Che impatto ha avuto il tuo progetto?`,
  share_a_quote_such_as_from_a_beneficiary: `Condividi un preventivo, ad esempio quello di un beneficiario`,
  quote_by: `Citazione di`,
  share_a_photo_or_other_media: `Condividi una foto o altri contenuti multimediali`,
  what_happens_next_for_example_are_you_planning_to_develop_your_project_further: `Cosa succede dopo, ad esempio, hai intenzione di sviluppare ulteriormente il tuo progetto?`,
  if_you_would_like_to_share_anything_else_with_the_company_please_use_the_box_below: `Se desideri condividere qualcos'altro con l'azienda, utilizza la casella sottostante`,
  the_company_has_requested_some_additional_information: `L'azienda ha richiesto alcune informazioni aggiuntive.`,
  content_agreement: `Accordo sui contenuti`,
  view_agreement: `Visualizza accordo`,
  application_agreement: `Contratto di applicazione`,
  send_message: `Invia messaggio`,
  this_final_Report_is_for: `Questo rapporto finale è per`,
  company_questions: `Domande aziendali`,
  next_steps: `Passaggi successivi`,
  additional_details: `Ulteriori dettagli`,
  objectives_and_outcomes: `Obiettivi e risultati`,
  planned: `Pianificato`,
  actual: `Reale`,
  days: `Giorni`,
  of_equivalent_value: `di valore equivalente`,
  case_study: `Caso di studio`,
  includes_changes: `Include modifiche`,
  hundred_as_planned: `100% come previsto`,
  show_planned_efforts: `Mostra gli sforzi pianificati`,
  final: `Finale`,
  support_awarded: `Supporto assegnato`,
  password_reset_expired: `Reimpostazione password scaduta`,
  please_select_forgot_password_again_and_click_on_the_email_to_reset_your_password_within_fifteen_minutes: `Seleziona nuovamente "Password dimenticata" e fai clic sull'e-mail per reimpostare la password entro 15 minuti.`,
  please_check_check_your_spam_folder_if_the_email_is_not_immediately_visible: `Controlla la cartella spam se l'e-mail non è immediatamente visibile.`,
  request: `Richiesta`,
  please_note_this_email_address_needs_to_match_the_address: `Nota: questo indirizzo email deve corrispondere all'indirizzo a cui hai ricevuto l'invito.`,
  an_access_email_has_sent_to: `Un'e-mail di accesso è stata inviata a:`,
  you_can_close_this_tab: `Puoi chiudere questa scheda.`,
  we_couldnt_find_your_email_address: `Non siamo riusciti a trovare il tuo indirizzo email. Assicurati che sia uguale all'e-mail di invito.`,
  the_feedback_portal_link_has_now_expired: `Il collegamento al Portale di feedback è scaduto.`,
  please_contact_your_programme_administrator_if_you_still_require_access: `Contatta l'amministratore del programma se hai ancora bisogno dell'accesso.`,
  verify: `Verificare`,
  the_email_address_entered_does_not_match_your_unique_link_please_ensure_it_is_the_same_as_your_invitation_email: `L'indirizzo email inserito non corrisponde al tuo collegamento univoco. Assicurati che sia uguale all'e-mail di invito.`,
  email_entered: `E-mail inserita`,
  try_again: `Riprova`,
  welcome_to_your_voting_panel: `Benvenuto nel tuo pannello di votazione!`,
  please_click_review_to_assess_each_application_and_then_cast_your_vote: `Fai clic su "Rivedi" per valutare ciascuna domanda e quindi esprimere il tuo voto.`,
  please_enter_your_name: `Per favore inserisci il tuo nome`,
  registered_charity: `Ente di beneficenza registrato`,
  charitable_company: `Compagnia di beneficenza`,
  community_interest_company: `Società di interesse comunitario`,
  charitable_trust: `Fondo di beneficenza`,
  for_profit_company: `Società a scopo di lucro`,
  academic_institution: `Istituzione accademica`,
  government_linked_entity: `Entità collegata al governo`,
  parish_or_community_council: `Consiglio parrocchiale o comunitario`,
  please_upload_a_copy_of_your_governing_document1: `Si prega di caricare una copia del documento governativo`,
  please_upload_a_copy_of_your_governing_document2: `Si prega di caricare una copia del documento governativo`,
  please_upload_a_copy_of_your_governing_document4: `Si prega di caricare una copia del documento governativo`,
  insert_number: `Inserisci numero`,
  bring_the_project_to_life_share_pictures_of_what_you_will_be_changing_or_plan_to_achieve: `Dai vita al progetto. Condividi le foto di ciò che cambierai o intendi ottenere.`,
  please_select_an_existing_user_or_invite_a_new_one: `Seleziona un utente esistente o invitane uno nuovo.`,
  country_af: `Afghanistan`,
  country_ax: `Isole Åland`,
  country_al: `Albania`,
  country_dz: `Algeria`,
  country_as: `Samoa americane`,
  country_ad: `Andorra`,
  country_ao: `L'Angola`,
  country_ai: `Anguilla`,
  country_aq: `Antartide`,
  country_ag: `Antigua e Barbuda`,
  country_ar: `Argentina`,
  country_am: `Armenia`,
  country_aw: `Aruba`,
  country_au: `Australia`,
  country_at: `Austria`,
  country_az: `Azerbaigian`,
  country_bs: `Bahamas`,
  country_bh: `Bahrein`,
  country_bd: `Bangladesh`,
  country_bb: `Barbados`,
  country_by: `Bielorussia`,
  country_be: `Belgio`,
  country_bz: `Belize`,
  country_bj: `Benin`,
  country_bm: `Bermude`,
  country_bt: `Bhutan`,
  country_bo: `Bolivia, Stato Plurinazionale`,
  country_bq: `Bonaire, Sint Eustatius e Saba`,
  country_ba: `Bosnia ed Erzegovina`,
  country_bw: `Botswana`,
  country_bv: `Isola Bouvet`,
  country_br: `Brasile`,
  country_io: `Territorio britannico dell'Oceano Indiano`,
  country_bn: `Brunei Darussalam`,
  country_bg: `Bulgaria`,
  country_bf: `Burkina Faso`,
  country_bi: `Burundi`,
  country_cv: `Capo Verde`,
  country_kh: `Cambogia`,
  country_cm: `Camerun`,
  country_ca: `Canada`,
  country_ky: `Isole Cayman`,
  country_cf: `Repubblica Centrafricana`,
  country_td: `Chad`,
  country_cl: `Chile`,
  country_cn: `Cina`,
  country_cx: `Isola di Natale`,
  country_cc: `Isole Cocos (Keeling).`,
  country_co: `Colombia`,
  country_km: `Comore`,
  country_cg: `Congo`,
  country_cd: `Congo, Repubblica Democratica del`,
  country_ck: `Isole Cook`,
  country_cr: `Costarica`,
  country_ci: `Costa d'Avorio`,
  country_hr: `Croazia`,
  country_cu: `Cuba`,
  country_cw: `Curaçao`,
  country_cy: `Cipro`,
  country_cz: `Cechia`,
  country_dk: `Danimarca`,
  country_dj: `Gibuti`,
  country_dm: `Dominica`,
  country_do: `Repubblica Dominicana`,
  country_ec: `Ecuador`,
  country_eg: `Egitto`,
  country_sv: `El Salvador`,
  country_gq: `Guinea Equatoriale`,
  country_er: `Eritrea`,
  country_ee: `Estonia`,
  country_sz: `Swaziland`,
  country_et: `Etiopia`,
  country_fk: `Isole Falkland (Malvine)`,
  country_fo: `Isole Faroe`,
  country_fj: `Figi`,
  country_fi: `Finlandia`,
  country_fr: `Francia`,
  country_gf: `Guiana francese`,
  country_pf: `Polinesia francese`,
  country_tf: `Territori francesi del sud`,
  country_ga: `Gabon`,
  country_gm: `Gambia`,
  country_ge: `Georgia`,
  country_de: `Germania`,
  country_gh: `Ghana`,
  country_gi: `Gibilterra`,
  country_gr: `Grecia`,
  country_gl: `Groenlandia`,
  country_gd: `Grenada`,
  country_gp: `Guadalupa`,
  country_gu: `Guam`,
  country_gt: `Guatemala`,
  country_gg: `Guernsey`,
  country_gn: `Guinea`,
  country_gw: `Guinea-Bissau`,
  country_gy: `Guyana`,
  country_ht: `Haiti`,
  country_hm: `Isole Heard e McDonald`,
  country_va: `Santa Sede`,
  country_hn: `Honduras`,
  country_hk: `Hong Kong`,
  country_hu: `Ungheria`,
  country_is: `Islanda`,
  country_in: `India`,
  country_id: `Indonesia`,
  country_ir: `Iran, Repubblica islamica di`,
  country_iq: `Iraq`,
  country_ie: `Irlanda`,
  country_im: `Isola di Man`,
  country_il: `Israele`,
  country_it: `Italia`,
  country_jm: `Giamaica`,
  country_jp: `Giappone`,
  country_je: `Maglia`,
  country_jo: `Giordania`,
  country_kz: `Kazakistan`,
  country_ke: `Kenia`,
  country_ki: `Kiribati`,
  country_kp: `Corea, Repubblica Popolare Democratica di`,
  country_kr: `Corea, Repubblica di`,
  country_kw: `Kuwait`,
  country_kg: `Kirghizistan`,
  country_la: `Repubblica Democratica Popolare del Laos`,
  country_lv: `Lettonia`,
  country_lb: `Libano`,
  country_ls: `Lesoto`,
  country_lr: `Liberia`,
  country_ly: `Libia`,
  country_li: `Liechtenstein`,
  country_lt: `Lituania`,
  country_lu: `Lussemburgo`,
  country_mo: `Macao`,
  country_mg: `Madagascar`,
  country_mw: `Malawi`,
  country_my: `Malaysia`,
  country_mv: `Maldive`,
  country_ml: `Mali`,
  country_mt: `Malta`,
  country_mh: `Isole Marshall`,
  country_mq: `Martinica`,
  country_mr: `La Mauritania`,
  country_mu: `Maurizio`,
  country_yt: `Mayotte`,
  country_mx: `Messico`,
  country_fm: `Micronesia, Stati Federati di`,
  country_md: `Moldavia, Repubblica di`,
  country_mc: `Monaco`,
  country_mn: `Mongolia`,
  country_me: `Montenegro`,
  country_ms: `Montserrat`,
  country_ma: `Marocco`,
  country_mz: `Mozambico`,
  country_mm: `Myanmar`,
  country_na: `Namibia`,
  country_nr: `Nauru`,
  country_np: `Nepal`,
  country_nl: `Paesi Bassi, Regno dei`,
  country_nc: `Nuova Caledonia`,
  country_nz: `Nuova Zelanda`,
  country_ni: `Nicaragua`,
  country_ne: `Niger`,
  country_ng: `Nigeria`,
  country_nu: `Niue`,
  country_nf: `Isola Norfolk`,
  country_mk: `Macedonia del Nord`,
  country_mp: `Isole Marianne Settentrionali`,
  country_no: `Norvegia`,
  country_om: `Oman`,
  country_pk: `Pakistan`,
  country_pw: `Palau`,
  country_ps: `Palestina, Stato di`,
  country_pa: `Panama`,
  country_pg: `Papua Nuova Guinea`,
  country_py: `Paraguay`,
  country_pe: `Perù`,
  country_ph: `Filippine`,
  country_pn: `Pitcairn`,
  country_pl: `Polonia`,
  country_pt: `Portogallo`,
  country_pr: `Porto Rico`,
  country_qa: `Qatar`,
  country_re: `Riunione`,
  country_ro: `Romania`,
  country_ru: `Federazione Russa`,
  country_rw: `Ruanda`,
  country_bl: `San Bartolomeo`,
  country_sh: `Sant'Elena, Ascensione e Tristan da Cunha`,
  country_kn: `Saint Kitts e Nevis`,
  country_lc: `Santa Lucia`,
  country_mf: `Saint Martin (parte francese)`,
  country_pm: `Saint Pierre e Miquelon`,
  country_vc: `Saint Vincent e Grenadine`,
  country_ws: `Samoa`,
  country_sm: `San Marino`,
  country_st: `Sao Tomé e Principe`,
  country_sa: `Arabia Saudita`,
  country_sn: `Senegal`,
  country_rs: `Serbia`,
  country_sc: `Seychelles`,
  country_sl: `Sierra Leone`,
  country_sg: `Singapore`,
  country_sx: `Sint Maarten (parte olandese)`,
  country_sk: `Slovacchia`,
  country_si: `Slovenia`,
  country_sb: `Isole Salomone`,
  country_so: `Somalia`,
  country_za: `Sudafrica`,
  country_gs: `Georgia del Sud e Isole Sandwich Meridionali`,
  country_ss: `Sudan del Sud`,
  country_es: `Spagna`,
  country_lk: `Sri Lanka`,
  country_sd: `Sudan`,
  country_sr: `Suriname`,
  country_sj: `Svalbard e Jan Mayen`,
  country_se: `Svezia`,
  country_ch: `Svizzera`,
  country_sy: `Repubblica araba siriana`,
  country_tw: `Taiwan, provincia della Cina`,
  country_tj: `Tagikistan`,
  country_tz: `Tanzania, Repubblica Unita di`,
  country_th: `Tailandia`,
  country_tl: `Timor Est`,
  country_tg: `Togo`,
  country_tk: `Tokelau`,
  country_to: `Tonga`,
  country_tt: `Trinidad e Tobago`,
  country_tn: `Tunisia`,
  country_tr: `Turchia`,
  country_tm: `Turkmenistan`,
  country_tc: `Isole Turks e Caicos`,
  country_tv: `Tuvalu`,
  country_ug: `Uganda`,
  country_ua: `Ucraina`,
  country_ae: `Emirati Arabi Uniti`,
  country_gb: `Regno Unito di Gran Bretagna e Irlanda del Nord`,
  country_us: `Stati Uniti d'America`,
  country_um: `Isole minori esterne degli Stati Uniti`,
  country_uy: `Uruguay`,
  country_uz: `Uzbekistan`,
  country_vu: `Vanuatu`,
  country_ve: `Venezuela, Repubblica Bolivariana di`,
  country_vn: `Vietnam`,
  country_vg: `Isole Vergini (britanniche)`,
  country_vi: `Isole Vergini (Stati Uniti)`,
  country_wf: `Wallis e Futuna`,
  country_eh: `Sahara occidentale`,
  country_ye: `Yemen`,
  country_zm: `Zambia`,
  country_zw: `Zimbabwe`
  }

export default itLocale;
